import { getIntentName, getNumber, getNDR, getNDRDate, getAttemptCount, getAWBValue, getLatestShipmentStatus, setLatestShipmentStatus, getIsOTPValidated, setAttemptCount, setAWBValue, setBusinessType, getBusinessType, setClientName, setCurrentFlow, getCurrentFlow, setDDT, setEDD, setIntentName, setIntentTicket, setIntentValue, setNDR, setNDRDate, setAddressUpdateStep, setPddBreach, setReattemptDate, setShipmentStatus, setShipmentType, setWHHandOver, setRiderName, setNdrVerificationSource, getRiderName, getNdrVerificationSource, setNdrShipmentSnapshot, getNdrShipmentSnapshot, setNdrConcernsActive, isNdrConcernsActive, setPncReschedulePending, setAdiPostAddressPending, isAdiPostAddressPending, setNprShipmentSnapshot, getNprShipmentSnapshot, setNprConcernsActive, isNprConcernsActive, clearAltMobileOtpState } from '../components/SessionStorage';

const { fetchOptionsOfInput, getFutureDeliveryDates } = require('./OptionsHandler');
const { constants } = require('./config/constants');

const additionalOptions = constants.prompt_of_additional_options;
const UPDATE_CONTACT_ADDRESS = constants.UPDATE_CONTACT_ADDRESS;
const UPDATE_ALTERNATE_CONTACT = constants.UPDATE_ALTERNATE_CONTACT;
const UPDATE_ALTERNATE_CONTACT_BUTTON = constants.UPDATE_ALTERNATE_CONTACT_BUTTON;
const UPDATE_CONTACT_DETAILS_MENU = constants.UPDATE_CONTACT_DETAILS_MENU;
const CANCEL_ORDER = constants.CANCEL_ORDER;

const {
    NDR_CWFD_AGREEMENT,
    NDR_CWFD_CALL_LOG,
    NDR_CWFD_REATTEMPT,
    NDR_CWFD_REATTEMPT_DELAY,
    NDR_CWFD_MAX_ATTEMPTS,
    NDR_CWFD_FLOW_END,
    NDR_CRA_AGREEMENT,
    NDR_CRA_CALL_LOG,
    NDR_CRA_REATTEMPT,
    NDR_CRA_REATTEMPT_DELAY,
    NDR_CRA_MAX_ATTEMPTS,
    NDR_CRA_FLOW_END,
    NDR_ADI_AGREEMENT,
    NDR_ADI_CALL_LOG,
    NDR_ADI_REATTEMPT,
    NDR_ADI_REATTEMPT_DELAY,
    NDR_ADI_FLOW_END,
    NPR_ADI_AGREEMENT,
    NPR_ADI_CALL_LOG,
    NPR_ADI_REATTEMPT,
    NPR_ADI_FLOW_END,
    NDR_PNC_MAX_ATTEMPTS,
    NDR_PNC_REATTEMPT,
    NDR_PNC_REATTEMPT_DELAY,
    NDR_PNC_RESCHEDULE,
    NDR_PNC_DATE_SELECTION,
    NDR_PNC_FLOW_END,
    RPCANCEL_REFUND_MAX_ATTEMPTS,
    RPCANCEL_REFUND_REATTEMPT,
    RPCANCEL_REFUND_RESCHEDULE,
    RPCANCEL_REFUND_DATE_SELECTION,
    RPCANCEL_REFUND_FLOW_END,
    RPCANCEL_PICKUP_AGREEMENT,
    RPCANCEL_PICKUP_CALL_LOG,
    RPCANCEL_PICKUP_REATTEMPT,
    RPCANCEL_PICKUP_MAX_ATTEMPTS,
    RPCANCEL_PICKUP_FLOW_END,
    NPR_RESCHEDULE_PICKUP,
    NPR_PICKUP_DATE_SELECTION,
    NPR_HANDED_AGREEMENT,
    NPR_HANDED_CALL_LOG,
    NPR_HANDED_NOT_VALIDATED,
    NPR_HANDED_FLOW_END,
    NPR_CWFP_AGREEMENT,
    NPR_CWFP_CALL_LOG,
    NPR_CWFP_REATTEMPT,
    NPR_CWFP_FLOW_END,
    NPR_PICKUP_WHERE_IS_LABEL,
    STILL_HAVE_QUERY,
    NDR_ENQUIRY_MENU,
    NDR_SHIPMENT_CONCERNS_MENU,
    NDR_ENQUIRY_MONGO_TYPE,
    NDR_SHIPMENT_CONCERNS_MONGO_TYPE,
    SHIPMENT_CONCERNS_BUTTON,
    NPR_SHIPMENT_CONCERNS_MENU,
    NPR_SHIPMENT_CONCERNS_MONGO_TYPE,
    RESCHEDULE_PICKUP,
    RESCHEDULE_SHIPMENT,
    SELF_COLLECT_SHIPMENT,
    CUSTOMER_CARE_NUMBER,
    DELIVERED_SHIPMENT_CONCERNS_MENU,
    DELIVERED_SHIPMENT_CONCERNS_MONGO_TYPE,
    DELIVERED_NOT_RECEIVED,
    DELIVERED_NOT_RECEIVED_AGREEMENT,
    DELIVERED_INCORRECT_SHIPMENT_PREFIX,
    DELIVERED_INCORRECT_SHIPMENT_FLOW,
    DELIVERED_FLOW_END,
    DELIVERED_USE_MONGO_MENUS,
    DELIVERED_ENQUIRY_MENU_FALLBACK,
} = constants;

const ADDRESS_INCOMPLETE_NDR_MSG = "Your shipment couldn't be completed because our rider couldn't find your address. To complete the shipment kindly enter your pincode below.";
const ADDRESS_INCOMPLETE_NPR_MSG = "Your pickup couldn't be completed because our rider couldn't find your address. To complete the pickup kindly enter your pincode below.";
const NPR_ADI_ADDRESS_UPDATED_MSG = 'Your address has been updated. Your pickup will be attempted soon. Thankyou';
const NPR_ADI_AGREE_THANKS = 'Alright, have a good day!';
const ADI_AGREEMENT_PROMPT = 'As per our records, Our rider attempted to reach you- do you agree with this?';

const CWFD_CALL_LOG_PROMPT = 'Could you please help us understand which particular attempt you disagree with?';
const CWFD_AGREE_THANKS = 'Thankyou for your feedback.';
const CWFD_MAX_ATTEMPTS_MSG = 'We apologise for the inconvenience. However, your shipment has been cancelled after maximum attempts. For further help, kindly reach out to our customer care team at {number}.';
const CRA_MAX_ATTEMPTS_MSG = CWFD_MAX_ATTEMPTS_MSG;

const PNC_MAX_ATTEMPTS_MSG = CWFD_MAX_ATTEMPTS_MSG;
const PNC_RESCHEDULE_PROMPT = 'Your shipment will be attempted soon. Do you want to reschedule the shipment?';
const PNC_SELECT_DATE_PROMPT = 'Please select the date below for your shipment delivery';
const PNC_NO_CHANGES_MSG = 'No changes made! Thankyou';

const HANDED_OVER_MSG = 'Your pickup has been handed to other courier.';

const RPCANCEL_REFUND_MAX_ATTEMPTS_MSG = 'Your pickup has been cancelled after maximum attempts.';
const RPCANCEL_REFUND_RESCHEDULE_PROMPT = 'Your shipment will be picked soon. Do you want to reschedule your pickup?';
const RPCANCEL_REFUND_SELECT_DATE_PROMPT = 'Please select the date below for your pickup attempt';
const RPCANCEL_REFUND_NO_CHANGES_MSG = 'No changes made! Thankyou';
const RPCANCEL_PICKUP_MAX_ATTEMPTS_MSG = 'We are sorry to inform you that your pickup has been cancelled after maximum attempts.';

const normalizeText = (value) => String(value || '').trim().toLowerCase();

const normalizeReasonText = (value) => (
    String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
);

const getShipmentNdrBlob = (shipment) => normalizeReasonText(
    [
        shipment?.ndrCode,
        shipment?.NdrCode,
        shipment?.lastNDR,
        shipment?.LastNDR,
        shipment?.lastNDRUserProcess,
        shipment?.LastNDRUserProcess,
        shipment?.userProcess,
        shipment?.UserProcess,
        shipment?.notificationType,
        shipment?.NotificationType,
        shipment?.notificationStatus,
        shipment?.NotificationStatus,
    ]
        .filter((value) => value != null && String(value).trim() !== '')
        .join(' ')
);

// Concerns menu must use LastNDR only — UserProcess is often a process state (e.g. CWFD/OFD).
const getShipmentLastNdrReasonBlob = (shipment) => normalizeReasonText(
    [
        shipment?.lastNDR,
        shipment?.LastNDR,
        shipment?.lastNDRUserProcess,
        shipment?.LastNDRUserProcess,
    ]
        .filter((value) => value != null && String(value).trim() !== '')
        .join(' ')
);

const pickShipmentField = (shipment, ...keys) => {
    for (const key of keys) {
        const value = shipment?.[key];
        if (value != null && value !== '' && value !== 'None') {
            return value;
        }
    }
    return null;
};

const normalizeShipmentSnapshot = (shipment) => {
    if (!shipment) {
        return null;
    }

    const orderRoot = shipment.ShipmentDetails || shipment;
    const inner = orderRoot?.ShipmentDetails || shipment;
    const orderDetails = orderRoot?.OrderDetails || shipment?.OrderDetails || {};

    const normalized = {
        ...shipment,
        poid: pickShipmentField(shipment, 'poid', 'shippingId', 'ShippingID')
            || pickShipmentField(orderRoot, 'ShippingID'),
        latestStatus: pickShipmentField(shipment, 'latestStatus', 'LatestStatus')
            || pickShipmentField(orderRoot, 'LatestStatus'),
        businessType: pickShipmentField(shipment, 'businessType', 'BusinessType', 'businessFlow', 'BusinessFlow')
            || pickShipmentField(inner, 'BusinessFlow', 'businessFlow'),
        status: pickShipmentField(shipment, 'status', 'Status') || pickShipmentField(inner, 'Status'),
        orderStatus: pickShipmentField(shipment, 'orderStatus', 'ShipmentStatus')
            || pickShipmentField(inner, 'ShipmentStatus'),
        userProcess: pickShipmentField(shipment, 'userProcess', 'UserProcess')
            || pickShipmentField(inner, 'UserProcess'),
        UserProcess: pickShipmentField(shipment, 'UserProcess', 'userProcess')
            || pickShipmentField(inner, 'UserProcess'),
        ndrCode: pickShipmentField(shipment, 'ndrCode', 'NdrCode')
            || pickShipmentField(inner, 'UserProcess')
            || pickShipmentField(orderRoot, 'LastNDR'),
        lastNDR: pickShipmentField(shipment, 'lastNDR', 'LastNDR')
            || pickShipmentField(orderRoot, 'LastNDR')
            || pickShipmentField(inner, 'LastNDR'),
        lastNDRUserProcess: pickShipmentField(shipment, 'lastNDRUserProcess', 'LastNDRUserProcess')
            || pickShipmentField(orderRoot, 'LastNDRUserProcess', 'LastNDRUserProcess')
            || pickShipmentField(orderRoot, 'LastNDR')
            || pickShipmentField(inner, 'LastNDRUserProcess')
            || pickShipmentField(inner, 'LastNDR'),
        lastNDRDate: pickShipmentField(shipment, 'lastNDRDate', 'LastNDRDate')
            || pickShipmentField(orderRoot, 'LastNDRDateTime'),
        lastNDRDateTime: pickShipmentField(shipment, 'lastNDRDateTime', 'LastNDRDateTime')
            || pickShipmentField(orderRoot, 'LastNDRDateTime'),
        reattemptDate: pickShipmentField(shipment, 'reattemptDate', 'ReattemptDate')
            || pickShipmentField(inner, 'ReattemptDate'),
        orderPDD: pickShipmentField(shipment, 'orderPDD', 'OrderPDD') || pickShipmentField(inner, 'PDD'),
        orderEDD: pickShipmentField(shipment, 'orderEDD', 'OrderEDD') || pickShipmentField(inner, 'EDD'),
        totalAttemptCount: pickShipmentField(shipment, 'totalAttemptCount', 'TotalAttemptCount')
            ?? pickShipmentField(inner, 'TotalAttemptCount'),
        notificationStatus: pickShipmentField(shipment, 'notificationStatus', 'NotificationStatus')
            || pickShipmentField(inner, 'NotificationStatus'),
        notificationType: pickShipmentField(shipment, 'notificationType', 'NotificationType')
            || pickShipmentField(inner, 'NotificationType'),
        processCode: pickShipmentField(shipment, 'processCode', 'ProcessCode')
            || pickShipmentField(inner, 'ProcessCode'),
        reasonCode: pickShipmentField(shipment, 'reasonCode', 'ReasonCode')
            || pickShipmentField(inner, 'ReasonCode'),
        isAuthenticNDR: pickShipmentField(shipment, 'isAuthenticNDR', 'IsAuthenticNDR')
            ?? pickShipmentField(orderRoot, 'IsAuthenticNDR'),
        clientName: pickShipmentField(shipment, 'clientName', 'ClientName')
            || pickShipmentField(inner, 'BusinessAccountName'),
        order_type: pickShipmentField(shipment, 'order_type', 'orderType')
            || pickShipmentField(orderDetails, 'OrderType'),
        ccNumber: pickShipmentField(shipment, 'ccNumber', 'CcNumber'),
        riderName: pickShipmentField(shipment, 'riderName', 'RiderName')
            || pickShipmentField(orderRoot, 'RiderName'),
        riderId: pickShipmentField(shipment, 'riderId', 'RiderId')
            || pickShipmentField(orderRoot, 'RiderId')
            || pickShipmentField(inner, 'SrID'),
        ndrVerificationSource: pickShipmentField(
            shipment,
            'ndrVerificationSource',
            'NDRNPRVerifiedSource',
            'NdrNprVerifiedSource',
        ) || pickShipmentField(orderRoot, 'NDRNPRVerifiedSource'),
        isNdrNprMarked: pickShipmentField(
            shipment,
            'isNdrNprMarked',
            'IsNDRNPRMarked',
            'IsNdrNprMarked',
        ) || pickShipmentField(orderRoot, 'IsNDRNPRMarked'),
        isPickUpCancelledVerified: pickShipmentField(
            shipment,
            'isPickUpCancelledVerified',
            'IsPickUpCancelledVerified',
        ) || pickShipmentField(orderRoot, 'IsPickUpCancelledVerified'),
        ndrNprMarkedDate: pickShipmentField(
            shipment,
            'ndrNprMarkedDate',
            'NDRNPRMarkedDate',
        ) || pickShipmentField(orderRoot, 'NDRNPRMarkedDate'),
    };

    if (normalized.latestStatus) {
        normalized.latestStatus = normalizeText(normalized.latestStatus);
    }
    if (normalized.businessType) {
        normalized.businessType = normalizeText(normalized.businessType);
    }
    if (normalized.order_type) {
        normalized.order_type = normalizeText(normalized.order_type);
    }

    return normalized;
};

const getPrimaryNdrReason = (shipment) => (
    pickShipmentField(shipment, 'lastNDR', 'LastNDR')
    || pickShipmentField(shipment, 'lastNDRUserProcess', 'LastNDRUserProcess')
    || pickShipmentField(shipment, 'ndrCode', 'NdrCode')
    || pickShipmentField(shipment, 'userProcess', 'UserProcess')
);

const getShipmentReattemptDate = (shipment) => (
    pickShipmentField(shipment, 'reattemptDate', 'ReattemptDate')
);

const isCwfdCnaReasonBlob = (blob) => (
    Boolean(blob) && (
        blob.includes('future delivery')
        || blob.includes('futuredelivery')
        || blob.includes('customer wants future')
        || blob.includes('customer not available')
        || blob.includes('cust not available')
    )
);

const isAddressIncompleteReason = (shipment) => {
    // UF may send reason only on UserProcess (mapped to ndrCode) or LastNDR* fields.
    const reason = normalizeText(
        shipment.lastNDRUserProcess
        || shipment.LastNDRUserProcess
        || shipment.ndrCode
        || shipment.lastNDR
        || shipment.LastNDR
        || shipment.userProcess
        || shipment.UserProcess
        || ''
    );
    return reason.includes('address incomplete');
};

const isAddressIncompleteNdr = (shipment) => {
    if (!shipment || normalizeText(shipment.businessType) !== 'forward') {
        return false;
    }
    if (!isAddressIncompleteReason(shipment)) {
        return false;
    }
    if (normalizeText(shipment.latestStatus) === 'ndr') {
        return true;
    }
    return normalizeText(shipment.status) === 'shipped'
        && normalizeText(shipment.orderStatus) === 'inscan'
        && Number(shipment.totalAttemptCount || 0) >= 1;
};

// routeAddressIncompleteNdr / tryRouteAddressIncompleteNdr are defined after

const isAddressIncompleteNpr = (shipment) => {
    if (!shipment || normalizeText(shipment.businessType) !== 'reverse') {
        return false;
    }
    if (!isAddressIncompleteReason(shipment)) {
        return false;
    }
    const latest = normalizeText(shipment.latestStatus);
    if (latest === 'npr' || latest === 'npr_pickup_not_done') {
        return true;
    }
    return normalizeText(shipment.status) === 'pending'
        && normalizeText(shipment.orderStatus) === 'pickupnotdone'
        && Number(shipment.totalAttemptCount || 0) >= 1;
};

const setNprAdiShipmentContext = (shipment) => {
    setShipmentStatus('Manifestation');
    setBusinessType('reverse');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR) {
        setNDR(shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (shipment.manifestDataReceived) {
        setDDT(shipment.manifestDataReceived);
    }
    if (shipment.reattemptDate && shipment.reattemptDate !== 'None') {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const configureNprAdiNotValidatedTicket = (shipment, deliveryDate) => {
    // NPR Reason sheet row 12 + ticket_conditions: Complaint / FakeNDR (133) / action 53 / Open
    setReattemptDate(deliveryDate);
    setIntentValue('133');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
    setCurrentFlow(NPR_ADI_REATTEMPT);
};

const configureNprAdiDisagreeTicket = () => {
    // Validated ADI disagree — same as NDR ADI / handed-over disagree:
    // Complaint (2) / Non Behavioral (20) / Call/OTP status-Disagreed (296) / Assigned to CC (379) / Open
    setIntentValue('296');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
};

const isValidatedAdiNpr = (shipment) => (
    // NPR-ADI Validated uses NDRNPRVerifiedSource only (OTP / Call / IVR)
    hasNdrVerificationSource(shipment)
);

const fetchNprAdiAgreementOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_ADI_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildAdiAgreementFallbackOptions();
        }
        return mongoOptions;
    } catch (error) {
        console.error('Error fetching NPR ADI agreement options from MongoDB:', error);
        return buildAdiAgreementFallbackOptions();
    }
};

const buildNprAdiCallLogOptions = async () => buildCwfdCallLogOptions();

const routeAddressIncompleteNpr = (shipment) => {
    // Direct ADI (Excel row 15): Request / Update address / subReason 97
    setNprAdiShipmentContext(shipment);
    setNprShipmentSnapshot(normalizeShipmentSnapshot(shipment));
    setIntentValue('97');
    setIntentName('update-contact-address');
    setIntentTicket('update-contact-address-yes');
    setCurrentFlow(UPDATE_CONTACT_ADDRESS);
    setAddressUpdateStep('pincode');
    setAdiPostAddressPending(true);
    return ADDRESS_INCOMPLETE_NPR_MSG;
};

const tryRouteAddressIncompleteNpr = (shipment) => {
    const normalized = normalizeShipmentSnapshot(shipment);
    if (!isAddressIncompleteNpr(normalized)) {
        return null;
    }
    return routeAddressIncompleteNpr(normalized);
};

// Called after Direct ADI address ticket succeeds for NPR Address incomplete.
const continueNprAdiFlowAfterAddressUpdate = async () => {
    const shipment = normalizeShipmentSnapshot(getNprShipmentSnapshot());
    if (!shipment || !isAddressIncompleteNpr(shipment)) {
        return null;
    }

    setNprAdiShipmentContext(shipment);

    if (isValidatedAdiNpr(shipment)) {
        setCurrentFlow(NPR_ADI_AGREEMENT);
        return {
            type: 'agreement',
            messages: await fetchNprAdiAgreementOptions(),
        };
    }

    // Not validated (flowchart + Excel row 12): pickup reattempt + FakeNDR ticket
    const deliveryDate = formatDateOnly(shipment.reattemptDate) || getFutureDate();
    configureNprAdiNotValidatedTicket(shipment, deliveryDate);
    return {
        type: 'complaint',
        messages: `Your pickup will be attempted on ${deliveryDate}.`,
    };
};

const formatDateOnly = (dateStr) => {
    if (!dateStr || dateStr === 'None') {
        return '';
    }
    return String(dateStr).split(' ')[0];
};

const formatNdrDisplayDate = (dateStr) => {
    const datePart = formatDateOnly(dateStr);
    if (!datePart) {
        return '';
    }
    const pieces = datePart.split('-');
    if (pieces.length === 3 && pieces[0].length === 4) {
        return `${pieces[2]}-${pieces[1]}-${pieces[0]}`;
    }
    return datePart;
};

const formatNdrDisplayTime = (dateStr) => {
    if (!dateStr || dateStr === 'None') {
        return '';
    }
    const parts = String(dateStr).trim().split(' ');
    if (parts.length < 2) {
        return '';
    }
    return parts[1].substring(0, 8);
};

const parseShipmentDate = (dateStr) => {
    if (!dateStr || dateStr === 'None') {
        return null;
    }
    const part = String(dateStr).trim().split(' ')[0];
    const pieces = part.split('-');
    if (pieces.length !== 3) {
        return null;
    }
    if (pieces[0].length === 4) {
        return new Date(`${pieces[0]}-${pieces[1]}-${pieces[2]}T00:00:00`);
    }
    return new Date(`${pieces[2]}-${pieces[1]}-${pieces[0]}T00:00:00`);
};

const getShipmentUserProcess = (shipment) => normalizeText(
    shipment?.userProcess || shipment?.UserProcess || shipment?.ndrCode || ''
);

const isRpcancelShipment = (shipment) => {
    const userProcess = getShipmentUserProcess(shipment);
    return userProcess === 'rpcancel'
        || normalizeText(shipment?.latestStatus) === 'rpcancel'
        || normalizeText(shipment?.status) === 'rpcancel'
        || normalizeText(shipment?.orderStatus) === 'rpcancel';
};

const isReattemptWithinPdd = (shipment, reattemptDateStr) => {
    const pddRaw = shipment?.orderPDD || shipment?.orderEDD;
    const pddDate = parseShipmentDate(pddRaw);
    const reattemptDate = parseShipmentDate(reattemptDateStr || shipment?.reattemptDate);
    if (!pddDate || !reattemptDate) {
        return true;
    }
    return reattemptDate.getTime() <= pddDate.getTime();
};

const configureNdrReattemptTicketByPdd = (shipment, deliveryDate, withinPddFlow, crossedPddFlow) => {
    // Ticket routing (NDR rows 30/31) compares API reattempt date vs PDD, not the user-facing date.
    const withinPdd = isReattemptWithinPdd(shipment);
    setPddBreach(withinPdd ? 'false' : 'true');
    if (withinPdd) {
        setIntentValue('105');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
        setCurrentFlow(withinPddFlow);
        return;
    }
    setIntentValue('139');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
    setCurrentFlow(crossedPddFlow);
};

const configurePncReattemptTicket = (shipment, deliveryDate) => {
    configureNdrReattemptTicketByPdd(
        shipment,
        deliveryDate,
        NDR_PNC_REATTEMPT,
        NDR_PNC_REATTEMPT_DELAY,
    );
};

const configureCwfdReattemptTicket = (shipment, deliveryDate) => {
    configureNdrReattemptTicketByPdd(
        shipment,
        deliveryDate,
        NDR_CWFD_REATTEMPT,
        NDR_CWFD_REATTEMPT_DELAY,
    );
};

const configureCraReattemptTicket = (shipment, deliveryDate) => {
    // NDR sheet row 22: within PDD → enquiry 105 closed; row 27: PDD crossed → complaint 139 open
    configureNdrReattemptTicketByPdd(
        shipment,
        deliveryDate,
        NDR_CRA_REATTEMPT,
        NDR_CRA_REATTEMPT_DELAY,
    );
};

const configureAdiReattemptTicket = (shipment, deliveryDate) => {
    // add2 unvalidated after address update: within PDD → enquiry 105; crossed PDD → complaint 139
    configureNdrReattemptTicketByPdd(
        shipment,
        deliveryDate,
        NDR_ADI_REATTEMPT,
        NDR_ADI_REATTEMPT_DELAY,
    );
};

const isCwfdShipmentRto = (shipment) => (
    normalizeText(shipment?.status) === 'rto'
    || normalizeText(shipment?.latestStatus) === 'rto'
    || normalizeText(shipment?.orderStatus) === 'rto'
    || normalizeText(shipment?.notificationType) === 'rto'
);

const isCwfdShipmentAtLastMile = (shipment) => {
    const currentHub = shipment?.currentHubID ?? shipment?.CurrentHubID;
    const finalHub = shipment?.finalHubID ?? shipment?.FinalDestinationID;
    if (currentHub == null || finalHub == null) {
        return false;
    }
    return String(currentHub) === String(finalHub);
};

// Shipment is at Last Mile when its current hub equals the final destination hub.
const isShipmentAtLastMile = (shipment) => isCwfdShipmentAtLastMile(shipment);

const configureNdrAgreementYesTicket = () => {
    // NPR Reason sheet row 21 / ticket_conditions 295: Call/OTP status-Agreed / Closed
    setIntentValue('295');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
};

const configureRpcancelPickupAgreementYesTicket = () => {
    // RVP Reason sheet row 13 — Thankyou for your feedback
    // Enquiry / Shipment status / Call status-Agreed / Information given / Closed
    setIntentValue('295-enquiry');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
};

const configureRpcancelPickupDisagreeTicket = () => {
    // RVP Reason sheet row 14 — We've created a ticket XYZ…
    // Complaint / Non Behaviour / Call status-Disagreed / Assigned to CC / Open
    setIntentValue('296-rvp');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
};

const configureNprHandedDisagreeTicket = () => {
    // NPR Reason sheet row 22: Complaint / Non Behaviour / Call status-Disagreed / Open
    // ticket_conditions: subReason 296 / action 379 Assigned to CC
    setIntentValue('296');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
};

const configureNprHandedNotValidatedTicket = () => {
    // NPR Reason sheet row 23: Enquiry / Handed over to other courier / Closed
    // ticket_conditions: subReason 301
    setIntentValue('301');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
};

const configureDeliveredAgreementYesTicket = () => {
    // Forward Flow row 12 — Call/OTP status-Agreed / Closed
    setIntentValue('295');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
};

const configureDeliveredIncorrectShipmentTicket = () => {
    // Forward Flow row 15 — Wrong shipment delivered / Open
    setIntentValue('135');
    setIntentName('complaint-raise-not-received');
    setIntentTicket('complaint-raise-not-received-ticket');
};

const configureCwfdMaxAttemptsTicket = (shipment) => {
    // Excel NDR row 14: validated-no, 3 attempts yes, RTO yes
    // Excel NDR row 15: validated-no, 3 attempts yes, RTO no, LM no
    // Both rows map to the same closed RTO enquiry ticket.
    setIntentValue('110-rto');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
    setCurrentFlow(NDR_CWFD_MAX_ATTEMPTS);
    if (isCwfdShipmentRto(shipment)) {
        setShipmentStatus('RTO');
    } else if (!isCwfdShipmentAtLastMile(shipment)) {
        setShipmentStatus('Inscan');
    }
};

const isCraShipmentRto = (shipment) => (
    normalizeText(shipment?.status) === 'rto'
    || normalizeText(shipment?.latestStatus) === 'rto'
    || normalizeText(shipment?.orderStatus) === 'rto'
    || normalizeText(shipment?.notificationType) === 'rto'
);

const configureCraMaxAttemptsTicket = (shipment) => {
    // Excel NDR row 23: unvalidated, 3 attempts, RTO yes — closed RTO enquiry
    // Excel NDR row 26: unvalidated, 3 attempts, RTO no, not at LM — closed RTO enquiry
    setIntentValue('110-rto');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
    setCurrentFlow(NDR_CRA_MAX_ATTEMPTS);
    if (isCraShipmentRto(shipment)) {
        setShipmentStatus('RTO');
    } else if (!isCwfdShipmentAtLastMile(shipment)) {
        setShipmentStatus('Inscan');
    }
};

const getVerificationSourceLabel = (source) => {
    const normalized = normalizeText(source);
    if (normalized === 'otp') {
        return 'OTP';
    }
    if (normalized === 'call' || normalized === 'ivr') {
        return 'Call';
    }
    return source || 'Call/OTP';
};

const isForwardBusinessShipment = (shipment) => {
    const businessType = normalizeText(shipment?.businessType || '');
    return businessType === 'forward' || businessType === '';
};

const getCwfdCnaReasonTexts = (shipment) => (
    [
        shipment?.ndrCode,
        shipment?.NdrCode,
        shipment?.lastNDRUserProcess,
        shipment?.LastNDRUserProcess,
        shipment?.lastNDR,
        shipment?.LastNDR,
        shipment?.userProcess,
        shipment?.UserProcess,
        shipment?.notificationType,
        shipment?.NotificationType,
    ]
        .filter((value) => value != null && String(value).trim() !== '')
        .map((value) => normalizeReasonText(value))
);

// Detects CWFD/CNA NDR reason from shipment fields (NOT the validation check).
const matchesCwfdCnaNdrReason = (shipment) => isCwfdCnaReasonBlob(getShipmentNdrBlob(shipment));

const hasNdrVerificationSource = (shipment) => {
    const source = normalizeText(
        shipment?.NDRNPRVerifiedSource
        || shipment?.ndrVerificationSource
        || shipment?.NdrNprVerifiedSource
        || ''
    );
    return source === 'otp' || source === 'call' || source === 'ivr';
};

// Checks whether a CWFD/CNA NDR shipment is validated.
const isValidatedCwfdCnaNdr = (shipment) => (
    hasNdrVerificationSource(shipment) 
);

const isCwfdOrCnaNdr = (shipment) => (
    Boolean(shipment)
    && matchesCwfdCnaNdrReason(shipment)
    && isForwardBusinessShipment(shipment)
);

const yesNoButtons = () => ([
    { type: 'button', content: 'YES' },
    { type: 'button', content: 'NO' },
]);

const buildCwfdAgreementPlaceholderValues = (shipment) => ({
    source: getVerificationSourceLabel(shipment.NDRNPRVerifiedSource),
    ndrReason: shipment.ndrCode || shipment.lastNDR || shipment.lastNDRUserProcess || 'the stated reason',
    riderName: shipment.riderName || shipment.RiderName || '',
    dateTime: shipment.lastNDRDateTime || shipment.lastNDRDate || '',
});

const interpolateCwfdTemplate = (template, shipment) => {
    const values = buildCwfdAgreementPlaceholderValues(shipment);
    return String(template || '')
        .replace(/\{source\}/g, values.source)
        .replace(/\{ndrReason\}/g, values.ndrReason)
        .replace(/\{riderName\}/g, values.riderName)
        .replace(/\{dateTime\}/g, values.dateTime)
        .replace(/\s{2,}/g, ' ')
        .trim();
};

const buildCwfdAgreementMessage = (shipment) => {
    const values = buildCwfdAgreementPlaceholderValues(shipment);
    const rider = values.riderName ? `Our rider ${values.riderName}` : 'Our rider';
    return `Your shipment was not delivered as it was verified over ${values.source} and '${values.ndrReason}'. ${rider} tried reaching you - Do you agree with this?`;
};

const buildCwfdAgreementFallbackOptions = (shipment) => ([
    { type: 'text', content: buildCwfdAgreementMessage(shipment) },
    ...yesNoButtons(),
]);

const fetchCwfdAgreementOptions = async (shipment) => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NDR_CWFD_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildCwfdAgreementFallbackOptions(shipment);
        }
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: interpolateCwfdTemplate(option.content, shipment),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching CWFD agreement options from MongoDB:', error);
        return buildCwfdAgreementFallbackOptions(shipment);
    }
};

const setCwfdShipmentContext = (shipment, { presetTicketIntent = true } = {}) => {
    if (presetTicketIntent) {
        setIntentValue('105');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
    }
    setShipmentStatus('Inscan');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR) {
        setNDR(shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (shipment.reattemptDate && shipment.reattemptDate !== 'None') {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const routeCwfdCnaNdr = async (shipment) => {
    const attempts = Number(shipment.totalAttemptCount || 0);
    const isValidated = isValidatedCwfdCnaNdr(shipment);
    setCwfdShipmentContext(shipment, { presetTicketIntent: !isValidated });

    if (isValidated) {
        setCurrentFlow(NDR_CWFD_AGREEMENT);
        return fetchCwfdAgreementOptions(shipment);
    }

    if (attempts >= 3) {
        configureCwfdMaxAttemptsTicket(shipment);
        const ccNumber = shipment.ccNumber || '02049116100';
        return CWFD_MAX_ATTEMPTS_MSG.replace('{number}', ccNumber);
    }

    const deliveryDate = formatDateOnly(shipment.reattemptDate) || getFutureDate();
    setReattemptDate(deliveryDate);
    configureCwfdReattemptTicket(shipment, deliveryDate);
    return `Your shipment will be attempted on ${deliveryDate}. Thankyou for your feedback.`;
};

const routeCwfdCnaIfNdrReasonMatches = async (shipment) => {
    if (!shipment || !isForwardBusinessShipment(shipment)) {
        return null;
    }
    if (!isCwfdCnaReasonBlob(getShipmentNdrBlob(shipment))) {
        return null;
    }
    return routeCwfdCnaNdr(shipment);
};

const tryRouteCwfdCnaNdr = async (shipment) => {
    if (isCwfdOrCnaNdr(shipment)) {
        return routeCwfdCnaNdr(shipment);
    }
    return routeCwfdCnaIfNdrReasonMatches(shipment);
};

const buildCwfdCallLogOptions = async () => {
    const { fetchIvrCallLogOptions } = require('./OptionsHandler');
    return fetchIvrCallLogOptions();
};

const isValidatedAdiNdr = (shipment) => (
    // NDR-ADI Validated uses NDRNPRVerifiedSource only (OTP / Call / IVR) — not IsAuthenticNDR
    hasNdrVerificationSource(shipment)
);

const setAdiShipmentContext = (shipment) => {
    setShipmentStatus('Inscan');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR) {
        setNDR(shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (shipment.reattemptDate && shipment.reattemptDate !== 'None') {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const buildAdiAgreementFallbackOptions = () => ([
    { type: 'text', content: ADI_AGREEMENT_PROMPT },
    ...yesNoButtons(),
]);

const fetchAdiAgreementOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NDR_ADI_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildAdiAgreementFallbackOptions();
        }
        return mongoOptions;
    } catch (error) {
        console.error('Error fetching ADI agreement options from MongoDB:', error);
        return buildAdiAgreementFallbackOptions();
    }
};

const buildAdiCallLogOptions = async () => buildCwfdCallLogOptions();

const routeDirectAdiAddressUpdate = () => {
    // Direct ADI (add1): always collect pincode/address first for Address incomplete
    setIntentValue('46');
    setIntentName('update-contact-address');
    setIntentTicket('update-contact-address-yes');
    setCurrentFlow(UPDATE_CONTACT_ADDRESS);
    setAddressUpdateStep('pincode');
    setAdiPostAddressPending(true);
    return ADDRESS_INCOMPLETE_NDR_MSG;
};

const routeAddressIncompleteNdr = async (shipment) => {
    setAdiShipmentContext(shipment);
    setNdrShipmentSnapshot(normalizeShipmentSnapshot(shipment));
    // add1 first — NDR-ADI Validated (add2) runs after address ticket creation
    return routeDirectAdiAddressUpdate();
};

// Called after Direct ADI address ticket succeeds. Regular "change address" never sets the pending flag.
const continueAdiFlowAfterAddressUpdate = async () => {
    if (!isAdiPostAddressPending()) {
        return null;
    }
    setAdiPostAddressPending(false);

    const ndrShipment = normalizeShipmentSnapshot(getNdrShipmentSnapshot());
    if (ndrShipment && isAddressIncompleteNdr(ndrShipment)) {
        setAdiShipmentContext(ndrShipment);

        if (isValidatedAdiNdr(ndrShipment)) {
            setCurrentFlow(NDR_ADI_AGREEMENT);
            return {
                type: 'agreement',
                messages: await fetchAdiAgreementOptions(),
            };
        }

        // Not validated: reattempt ticket, same as NPR ADI (isValidatedAdiNpr) branch order
        const deliveryDate = formatDateOnly(ndrShipment.reattemptDate) || getFutureDate();
        setReattemptDate(deliveryDate);
        configureAdiReattemptTicket(ndrShipment, deliveryDate);
        return {
            type: 'reattempt',
            messages: `Your shipment will be attempted on ${deliveryDate}.`,
        };
    }

    // NPR Address incomplete — same pending flag, separate snapshot / tickets
    return continueNprAdiFlowAfterAddressUpdate();
};

const tryRouteAddressIncompleteNdr = async (shipment) => {
    if (!isAddressIncompleteNdr(shipment)) {
        return null;
    }
    return routeAddressIncompleteNdr(shipment);
};

const isCraReasonBlob = (blob) => (
    Boolean(blob) && (
        blob.includes('refused to accept')
        || blob.includes('refuse to accept')
    )
);

const isCraProcessOrReasonCode = (shipment) => {
    const processCode = normalizeText(shipment?.processCode || shipment?.ProcessCode || '');
    const reasonCode = normalizeText(shipment?.reasonCode || shipment?.ReasonCode || '');
    return processCode === 'p035' || reasonCode === 'xbu00302';
};

const isCraReason = (shipment) => (
    isCraReasonBlob(getShipmentNdrBlob(shipment)) || isCraProcessOrReasonCode(shipment)
);

// Concerns hub customer_refuse.* — CRA only (not CNA / CWFD).
const isCraReasonForConcernsMenu = (shipment) => isCraReason(shipment);

const isCraNdr = (shipment) => {
    if (!shipment || !isForwardBusinessShipment(shipment)) {
        return false;
    }
    if (!isCraReason(shipment)) {
        return false;
    }
    if (normalizeText(shipment.latestStatus) === 'ndr' || normalizeText(shipment.latestStatus) === 'rto') {
        return true;
    }
    if (normalizeText(shipment.status) === 'rto') {
        return true;
    }
    return normalizeText(shipment.status) === 'shipped'
        && normalizeText(shipment.orderStatus) === 'inscan'
        && Number(shipment.totalAttemptCount || 0) >= 1;
};

// Checks whether a customer-refuse NDR shipment is validated.
const isValidatedCraNdr = (shipment) => (
    hasNdrVerificationSource(shipment)
);

const buildCraAgreementPlaceholderValues = (shipment) => ({
    source: getVerificationSourceLabel(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource),
    riderName: shipment.riderName || shipment.RiderName || '',
});

const buildCraAgreementMessage = (shipment) => {
    const values = buildCraAgreementPlaceholderValues(shipment);
    const rider = values.riderName ? `Our rider ${values.riderName}` : 'Our rider';
    return `Your shipment was not delivered as it was verified over ${values.source} and you refused to accept. ${rider} tried reaching you - Do you agree with this?`;
};

const buildCraAgreementFallbackOptions = (shipment) => ([
    { type: 'text', content: buildCraAgreementMessage(shipment) },
    ...yesNoButtons(),
]);

const fetchCraAgreementOptions = async (shipment) => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NDR_CRA_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildCraAgreementFallbackOptions(shipment);
        }
        const values = buildCraAgreementPlaceholderValues(shipment);
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: String(option.content || '')
                        .replace(/\{source\}/g, values.source)
                        .replace(/\{riderName\}/g, values.riderName)
                        .replace(/\{SR name\}/gi, values.riderName)
                        .replace(/\s{2,}/g, ' ')
                        .trim(),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching CRA agreement options from MongoDB:', error);
        return buildCraAgreementFallbackOptions(shipment);
    }
};

const setCraShipmentContext = (shipment, { presetTicketIntent = true } = {}) => {
    if (presetTicketIntent) {
        setIntentValue('105');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
    }
    setShipmentStatus(normalizeText(shipment.status) === 'rto' ? 'RTO' : 'Inscan');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.lastNDR || shipment.ndrCode || shipment.lastNDRUserProcess) {
        setNDR(shipment.lastNDR || shipment.ndrCode || shipment.lastNDRUserProcess);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (shipment.reattemptDate && shipment.reattemptDate !== 'None') {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const routeCraNdr = async (shipment) => {
    const attempts = Number(shipment.totalAttemptCount || 0);
    const isValidated = isValidatedCraNdr(shipment);
    setCraShipmentContext(shipment, { presetTicketIntent: !isValidated });

    if (isValidated) {
        setCurrentFlow(NDR_CRA_AGREEMENT);
        return fetchCraAgreementOptions(shipment);
    }

    if (attempts >= 3) {
        configureCraMaxAttemptsTicket(shipment);
        const ccNumber = shipment.ccNumber || '02066674200';
        return CRA_MAX_ATTEMPTS_MSG.replace('{number}', ccNumber);
    }

    const deliveryDate = formatDateOnly(shipment.reattemptDate) || getFutureDate();
    setReattemptDate(deliveryDate);
    configureCraReattemptTicket(shipment, deliveryDate);
    return `Your shipment will be attempted on ${deliveryDate}. Thankyou for your feedback.`;
};

const tryRouteCraNdr = async (shipment) => {
    if (!isCraNdr(shipment)) {
        return null;
    }
    return routeCraNdr(shipment);
};

const buildCraCallLogOptions = async () => buildCwfdCallLogOptions();

const isPaymentCouldNotBeCompletedReason = (shipment) => {
    const reason = getShipmentNdrBlob(shipment);
    return reason.includes('payment could not be completed')
        || reason.includes('cod not available')
        || reason.includes('cod amount not ready');
};

const isNdrPaymentCouldNotBeCompleted = (shipment) => {
    if (!shipment || !isForwardBusinessShipment(shipment)) {
        return false;
    }
    if (isRpcancelShipment(shipment)) {
        return false;
    }
    if (!isPaymentCouldNotBeCompletedReason(shipment)) {
        return false;
    }
    if (normalizeText(shipment.latestStatus) === 'ndr') {
        return true;
    }
    if (Number(shipment.totalAttemptCount || 0) >= 1) {
        return true;
    }
    return normalizeText(shipment.status) === 'shipped'
        && normalizeText(shipment.orderStatus) === 'inscan';
};

const hasPncReattemptDate = (shipment) => {
    const date = getShipmentReattemptDate(shipment);
    return Boolean(date && date !== 'None' && date !== null);
};

const resolveDeliveryReattemptDate = async (shipment) => {
    const reattemptRaw = getShipmentReattemptDate(shipment);
    if (!reattemptRaw) {
        return getFutureDate();
    }
    try {
        const splitReattemptDate = await splitDate(reattemptRaw);
        if (!splitReattemptDate) {
            return formatDateOnly(reattemptRaw) || getFutureDate();
        }
        if (splitReattemptDate > new Date()) {
            return formatDateOnly(reattemptRaw);
        }
        const eligibleDate = await getEligiblityDate(splitReattemptDate, 'Reattempt');
        if (eligibleDate === 'ASAP') {
            return getFutureDate();
        }
        return eligibleDate || formatDateOnly(reattemptRaw) || getFutureDate();
    } catch (error) {
        console.log('Error in resolveDeliveryReattemptDate', error);
        return formatDateOnly(reattemptRaw) || getFutureDate();
    }
};

const setPncShipmentContext = (shipment) => {
    setShipmentStatus('Inscan');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR) {
        setNDR(shipment.ndrCode || shipment.lastNDRUserProcess || shipment.lastNDR);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (hasPncReattemptDate(shipment)) {
        setReattemptDate(formatDateOnly(getShipmentReattemptDate(shipment)));
    }
};

const routeNdrPaymentCouldNotBeCompleted = async (shipment) => {
    setPncShipmentContext(shipment);
    const attempts = Number(shipment.totalAttemptCount || 0);

    if (attempts >= 3) {
        setCurrentFlow(NDR_PNC_MAX_ATTEMPTS);
        setIntentValue('110-rto');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
        const ccNumber = shipment.ccNumber || '02049116100';
        return PNC_MAX_ATTEMPTS_MSG.replace('{number}', ccNumber);
    }

    if (hasPncReattemptDate(shipment)) {
        const deliveryDate = formatDateOnly(getShipmentReattemptDate(shipment));
        setReattemptDate(deliveryDate);
        configurePncReattemptTicket(shipment, deliveryDate);
        return `Your shipment will be attempted on ${deliveryDate}. Thank you for your feedback.`;
    }

    setPncReschedulePending(true);
    setCurrentFlow(NDR_PNC_RESCHEDULE);
    return [
        { type: 'text', content: PNC_RESCHEDULE_PROMPT },
        { type: 'button', content: 'YES' },
        { type: 'button', content: 'NO' },
    ];
};

const tryRouteNdrPaymentCouldNotBeCompleted = async (shipment) => {
    if (!isNdrPaymentCouldNotBeCompleted(shipment)) {
        return null;
    }
    return routeNdrPaymentCouldNotBeCompleted(shipment);
};

const isReverseBusinessShipment = (shipment) => {
    const businessType = normalizeText(shipment?.businessType || shipment?.BusinessType);
    const businessFlow = normalizeText(shipment?.businessFlow || shipment?.BusinessFlow);
    return businessType === 'reverse' || businessFlow === 'reverse';
};

const isHandedToOtherCourierRpcancel = (shipment) => (
    normalizeText(shipment?.latestStatus) === 'rpcancel'
    || normalizeText(shipment?.status) === 'rpcancel'
    || normalizeText(shipment?.orderStatus) === 'rpcancel'
);

const isNdrNprMarkedShipment = (shipment) => {
    const value = shipment?.isNdrNprMarked
        ?? shipment?.IsNDRNPRMarked
        ?? shipment?.IsNdrNprMarked;
    if (value === true || value === 1 || value === '1') {
        return true;
    }
    const normalized = normalizeText(String(value ?? ''));
    return normalized === 'y' || normalized === 'yes' || normalized === 'true';
};

const isPickUpCancelledVerifiedShipment = (shipment) => {
    const verifiedValues = [
        shipment?.isPickUpCancelledVerified,
        shipment?.IsPickUpCancelledVerified,
    ];
    return verifiedValues.some((value) => (
        value === true
        || value === 1
        || value === '1'
        || String(value).toLowerCase() === 'true'
    ));
};

// Cancelled Pickup (RVP rows 11–14): LastNDR after OFP/CNA customer cancel.
const isCancelledPickupReason = (shipment) => {
    const reason = normalizeText(
        shipment?.lastNDR
        || shipment?.LastNDR
        || shipment?.lastNDRUserProcess
        || shipment?.LastNDRUserProcess
        || shipment?.ndrCode
        || ''
    );
    return reason.includes('pickup cancelled by customer after ofp')
        || reason.includes('pickup cancelled by customer after cna')
        || reason.includes('pickup cancelled by customer');
};

// UF AutoRPCancel may keep NPR cancel flags without a handed-over LastNDR — do not
// infer handed-over from flags alone; LastNDR text is the router (see isHandedToOtherCourierReason).

const isRefundReplacementFirstReason = (shipment) => {
    const reason = normalizeText(
        shipment.lastNDR
        || shipment.lastNDRUserProcess
        || shipment.ndrCode
        || shipment.userProcess
        || shipment.UserProcess
        || ''
    );
    return reason.includes('customer wants refund')
        || reason.includes('refund/replacement first')
        || reason.includes('refund replacement first');
};

const isRefundReplacementFirstRpcancel = (shipment) => {
    if (!shipment || !isReverseBusinessShipment(shipment)) {
        return false;
    }
    if (!isRefundReplacementFirstReason(shipment)) {
        return false;
    }
    return isRpcancelShipment(shipment);
};

// NPR pickup-not-done can carry the same LastNDR before the shipment becomes RPCancel.
// "Where is my shipment" must use the refund/replacement special flow — not the
// generic pending-pickup enquiry ticket from npr_pickup_not_done_flow.
const isRefundReplacementFirstNpr = (shipment) => {
    if (!shipment || !isReverseBusinessShipment(shipment)) {
        return false;
    }
    if (!isRefundReplacementFirstReason(shipment)) {
        return false;
    }
    if (isRpcancelShipment(shipment)) {
        return false;
    }
    const latest = normalizeText(shipment.latestStatus);
    if (latest === 'npr' || latest === 'npr_pickup_not_done') {
        return true;
    }
    return normalizeText(shipment.status) === 'pending'
        && normalizeText(shipment.orderStatus) === 'pickupnotdone';
};

const isRefundReplacementFirstShipment = (shipment) => (
    isRefundReplacementFirstRpcancel(shipment) || isRefundReplacementFirstNpr(shipment)
);

const hasRpcancelReattemptDate = (shipment) => {
    const date = shipment.reattemptDate;
    return Boolean(date && date !== 'None' && date !== null);
};

const setRefundReplacementContext = (shipment) => {
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
    setShipmentStatus('RPCancel');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode) {
        setNDR(shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (hasRpcancelReattemptDate(shipment)) {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
};

const buildRefundRescheduleFallbackOptions = () => ([
    { type: 'text', content: RPCANCEL_REFUND_RESCHEDULE_PROMPT },
    ...yesNoButtons(),
]);

const fetchRefundRescheduleOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_RESCHEDULE_PICKUP, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildRefundRescheduleFallbackOptions();
        }
        return mongoOptions;
    } catch (error) {
        console.error('Error fetching refund reschedule options from MongoDB:', error);
        return buildRefundRescheduleFallbackOptions();
    }
};

const fetchRefundPickupDateOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_PICKUP_DATE_SELECTION, false);
        const promptOption = Array.isArray(mongoOptions) && mongoOptions.length > 0
            ? mongoOptions.find((option) => option?.type === 'text') || mongoOptions[0]
            : null;
        const prompt = promptOption?.content || RPCANCEL_REFUND_SELECT_DATE_PROMPT;
        return getFutureDeliveryDates([{ type: 'text', content: prompt }]);
    } catch (error) {
        console.error('Error fetching refund pickup date options from MongoDB:', error);
        return getFutureDeliveryDates([{ type: 'text', content: RPCANCEL_REFUND_SELECT_DATE_PROMPT }]);
    }
};

const routeRefundReplacementFirst = async (shipment) => {
    setRefundReplacementContext(shipment);
    const attempts = Number(shipment.totalAttemptCount || 0);

    if (attempts >= 3) {
        setIntentValue('110');
        setCurrentFlow(RPCANCEL_REFUND_MAX_ATTEMPTS);
        return RPCANCEL_REFUND_MAX_ATTEMPTS_MSG;
    }

    if (hasRpcancelReattemptDate(shipment)) {
        setIntentValue('105');
        setCurrentFlow(RPCANCEL_REFUND_REATTEMPT);
        const pickupDate = formatDateOnly(shipment.reattemptDate);
        return `Your pickup will be attempted on ${pickupDate}. Thankyou for your feedback.`;
    }

    setCurrentFlow(RPCANCEL_REFUND_RESCHEDULE);
    return fetchRefundRescheduleOptions();
};

const tryRouteRefundReplacementFirst = async (shipment) => {
    if (!isRefundReplacementFirstShipment(shipment)) {
        return null;
    }
    return routeRefundReplacementFirst(shipment);
};

const isCustomerWantsFuturePickupReason = (shipment) => {
    // Explicit NPR reasons must win over shared process codes (e.g. P007), which
    // UF also attaches to non-CWFP cases like refund/replacement-first.
    if (isRefundReplacementFirstReason(shipment) || isAddressIncompleteReason(shipment)) {
        return false;
    }

    const reasonBlob = getShipmentNdrBlob(shipment);
    const notificationType = normalizeText(shipment?.notificationType || shipment?.NotificationType || '');
    const reasonCode = normalizeText(shipment?.reasonCode || shipment?.ReasonCode || '');
    const processCode = normalizeText(shipment?.processCode || shipment?.ProcessCode || '');
    const mentionsFuturePickup = reasonBlob.includes('future pickup')
        || reasonBlob.includes('requested for future pickup')
        || reasonBlob.includes('wants future pickup');

    if (mentionsFuturePickup) {
        return true;
    }

    // Process/reason codes are only a fallback when UF did not send a readable
    // LastNDR / UserProcess reason string.
    if (reasonBlob) {
        return false;
    }

    return notificationType === 'futuredelivery'
        || reasonCode === 'xbu00505'
        || processCode === 'p007';
};

const isCustomerWantsFuturePickupNpr = (shipment) => {
    if (!shipment || !isReverseBusinessShipment(shipment)) {
        return false;
    }
    if (!isCustomerWantsFuturePickupReason(shipment)) {
        return false;
    }
    if (normalizeText(shipment.latestStatus) === 'npr') {
        return true;
    }
    return normalizeText(shipment.status) === 'pending'
        && normalizeText(shipment.orderStatus) === 'pickupnotdone';
};

const isValidatedCustomerWantsFuturePickupNpr = (shipment) => (
    hasNdrVerificationSource(shipment)
);

const buildCwfpAgreementPlaceholderValues = (shipment) => {
    const rawDateTime = shipment.lastNDRDateTime || shipment.lastNDRDate || '';
    return {
        source: getVerificationSourceLabel(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource),
        riderName: shipment.riderName || shipment.RiderName || '',
        date: formatNdrDisplayDate(rawDateTime),
        time: formatNdrDisplayTime(rawDateTime),
    };
};

const buildCwfpAgreementMessage = (shipment) => {
    const values = buildCwfpAgreementPlaceholderValues(shipment);
    const rider = values.riderName ? `Our rider ${values.riderName}` : 'Our rider';
    const contactWhen = values.date && values.time
        ? `on ${values.date} at ${values.time}`
        : values.date
            ? `on ${values.date}`
            : '';
    return `Your shipment was not picked up as it was verified by you over ${values.source} and a future delivery was requested. ${rider} attempted to reach you ${contactWhen}. Do you agree with this?`;
};

const buildCwfpAgreementFallbackOptions = (shipment) => ([
    { type: 'text', content: buildCwfpAgreementMessage(shipment) },
    ...yesNoButtons(),
]);

const fetchCwfpAgreementOptions = async (shipment) => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_CWFP_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildCwfpAgreementFallbackOptions(shipment);
        }
        const values = buildCwfpAgreementPlaceholderValues(shipment);
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: String(option.content || '')
                        .replace(/\{source\}/gi, values.source)
                        .replace(/\{riderName\}/g, values.riderName)
                        .replace(/\{SR name\}/gi, values.riderName)
                        .replace(/\{date\}/g, values.date)
                        .replace(/\{time\}/g, values.time)
                        .replace(/\{dateTime\}/g, [values.date, values.time].filter(Boolean).join(' '))
                        .replace(/\s{2,}/g, ' ')
                        .trim(),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching CWFP agreement options from MongoDB:', error);
        return buildCwfpAgreementFallbackOptions(shipment);
    }
};

const setCwfpShipmentContext = (shipment, { presetTicketIntent = true } = {}) => {
    if (presetTicketIntent) {
        setIntentValue('59');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
    }
    setShipmentStatus('Manifestation');
    setBusinessType('reverse');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount != null) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode) {
        setNDR(shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (hasRpcancelReattemptDate(shipment)) {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const routeCustomerWantsFuturePickupNpr = async (shipment) => {
    const isValidated = isValidatedCustomerWantsFuturePickupNpr(shipment);
    setCwfpShipmentContext(shipment, { presetTicketIntent: !isValidated });

    if (isValidated) {
        setCurrentFlow(NPR_CWFP_AGREEMENT);
        return fetchCwfpAgreementOptions(shipment);
    }

    const pickupDate = formatDateOnly(shipment.reattemptDate) || getFutureDate();
    setCurrentFlow(NPR_CWFP_REATTEMPT);
    return `Your pickup will be attempted on ${pickupDate}. Thankyou!`;
};

const tryRouteCustomerWantsFuturePickupNpr = async (shipment) => {
    if (!isCustomerWantsFuturePickupNpr(shipment)) {
        return null;
    }
    return routeCustomerWantsFuturePickupNpr(shipment);
};

const isCancelledPickupRpcancel = (shipment) => {
    if (!shipment || !isReverseBusinessShipment(shipment)) {
        return false;
    }
    if (!isRpcancelShipment(shipment)) {
        return false;
    }
    // RPCancel + LastNDR "Handed over to other courier(s)" is the handed-over NPR flow.
    if (isHandedToOtherCourierReason(shipment)) {
        return false;
    }
    if (isRefundReplacementFirstReason(shipment)) {
        return false;
    }
    if (isCancelledPickupReason(shipment)) {
        return true;
    }
    // Generic rpcancel (no handed-over LastNDR) → cancelled-pickup family.
    return true;
};

const isValidatedCancelledPickupRpcancel = (shipment) => (
    // Flowchart: validated cancelled pickup when customer confirmed via OTP/Call/IVR.
    isPickUpCancelledVerifiedShipment(shipment) || hasNdrVerificationSource(shipment)
);

const buildCancelledPickupAgreementPlaceholderValues = (shipment) => {
    const rawDateTime = shipment.lastNDRDateTime || shipment.lastNDRDate || shipment.lastModifiedDate || '';
    return {
        source: getVerificationSourceLabel(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource),
        riderName: shipment.riderName || shipment.RiderName || '',
        date: formatNdrDisplayDate(rawDateTime),
        time: formatNdrDisplayTime(rawDateTime),
    };
};

const buildCancelledPickupAgreementMessage = (shipment) => {
    const values = buildCancelledPickupAgreementPlaceholderValues(shipment);
    const rider = values.riderName ? `Our rider ${values.riderName}` : 'Our rider';
    const contactWhen = values.date && values.time
        ? `on ${values.date} at ${values.time}`
        : values.date
            ? `on ${values.date}`
            : '';
    const sourceSuffix = values.source ? ` via ${values.source}` : '';
    return `As per your confirmation your pickup has been cancelled. ${rider} tried reaching you ${contactWhen}${sourceSuffix}. Do you agree with it?`;
};

const buildCancelledPickupAgreementFallbackOptions = (shipment) => ([
    { type: 'text', content: buildCancelledPickupAgreementMessage(shipment) },
    ...yesNoButtons(),
]);

const fetchCancelledPickupAgreementOptions = async (shipment) => {
    try {
        const mongoOptions = await fetchOptionsOfInput(RPCANCEL_PICKUP_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildCancelledPickupAgreementFallbackOptions(shipment);
        }
        const values = buildCancelledPickupAgreementPlaceholderValues(shipment);
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: String(option.content || '')
                        .replace(/\{source\}/gi, values.source)
                        .replace(/\{riderName\}/g, values.riderName)
                        .replace(/\{SR name\}/gi, values.riderName)
                        .replace(/\{date\}/g, values.date)
                        .replace(/\{time\}/g, values.time)
                        .replace(/\{dateTime\}/g, [values.date, values.time].filter(Boolean).join(' '))
                        .replace(/\s{2,}/g, ' ')
                        .trim(),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching cancelled pickup agreement options from MongoDB:', error);
        return buildCancelledPickupAgreementFallbackOptions(shipment);
    }
};

const setCancelledPickupContext = (shipment, { presetTicketIntent = true } = {}) => {
    // Validated agreement must NOT preset order-status — otherwise
    // applyPostOrderStatusFlowEffects creates a ticket immediately and
    // clearSelectedKeys wipes current-flow before YES/NO can run.
    if (presetTicketIntent) {
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
    }
    setShipmentStatus('RPCancel');
    setBusinessType('reverse');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount != null) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode) {
        setNDR(shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    if (hasRpcancelReattemptDate(shipment)) {
        setReattemptDate(formatDateOnly(shipment.reattemptDate));
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const routeCancelledPickupRpcancel = async (shipment) => {
    const attempts = Number(shipment.totalAttemptCount || 0);
    const isValidated = isValidatedCancelledPickupRpcancel(shipment);
    setCancelledPickupContext(shipment, { presetTicketIntent: !isValidated });

    if (!isValidated) {
        setCurrentFlow(RPCANCEL_PICKUP_AGREEMENT);
        return fetchCancelledPickupAgreementOptions(shipment);
    }

    if (attempts >= 3) {
        setIntentValue('110');
        setCurrentFlow(RPCANCEL_PICKUP_MAX_ATTEMPTS);
        const stillHaveOptions = await fetchStillHaveQueryOptions();
        return [
            { type: 'text', content: RPCANCEL_PICKUP_MAX_ATTEMPTS_MSG },
            ...stillHaveOptions,
        ];
    }

    const pickupDate = formatDateOnly(shipment.reattemptDate) || getFutureDate();
    setIntentValue('110');
    setCurrentFlow(RPCANCEL_PICKUP_REATTEMPT);
    return `Your pickup will be attempted on ${pickupDate}. Thankyou!`;
};

const tryRouteCancelledPickupRpcancel = async (shipment) => {
    if (!isCancelledPickupRpcancel(shipment)) {
        return null;
    }
    return routeCancelledPickupRpcancel(shipment);
};

const isHandedToOtherCourierReason = (shipment) => {
    const reason = getShipmentLastNdrReasonBlob(shipment);
    if (!reason) {
        return false;
    }
    // UF sends singular/plural and slight wording variants on LastNDR / LastNDRUserProcess.
    return reason.includes('handed over to other couriers')
        || reason.includes('handed over to other courier')
        || reason.includes('handed over to another courier')
        || reason.includes('handed to another courier')
        || (reason.includes('handed') && reason.includes('other courier'));
};

// === REMOVE_BEFORE_GO_LIVE: NPR flow only when LatestStatus is literally npr ===
const isNprSpecialFlowLatestStatus = (statusOrShipment) => {
    const status = typeof statusOrShipment === 'string' || statusOrShipment == null
        ? normalizeText(statusOrShipment)
        : normalizeText(
            statusOrShipment?.latestStatus
            || statusOrShipment?.LatestStatus
            || ''
        );
    return status === 'npr' || status === 'npr_pickup_not_done' || status === 'rpcancel';
};
// === END REMOVE_BEFORE_GO_LIVE ===

const isHandedToOtherCourierNpr = (shipment) => {
    if (!shipment || !isReverseBusinessShipment(shipment)) {
        return false;
    }
    // Handed-over is keyed off LastNDR text — not LatestStatus alone.
    if (!isHandedToOtherCourierReason(shipment)) {
        return false;
    }
    if (isHandedToOtherCourierRpcancel(shipment) || isNdrNprMarkedShipment(shipment)) {
        return true;
    }
    if (normalizeText(shipment.latestStatus) === 'npr') {
        return true;
    }
    return normalizeText(shipment.status) === 'pending'
        && normalizeText(shipment.orderStatus) === 'pickupnotdone'
        && Number(shipment.totalAttemptCount || 0) >= 1;
};

const buildHandedAgreementPlaceholderValues = (shipment) => {
    const rawDateTime = shipment.lastNDRDateTime
        || shipment.lastNDRDate
        || shipment.ndrNprMarkedDate
        || shipment.NDRNPRMarkedDate
        || '';
    const source = getVerificationSourceLabel(
        shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource
    );
    return {
        source,
        riderName: shipment.riderName || shipment.RiderName || '',
        date: formatNdrDisplayDate(rawDateTime),
        time: formatNdrDisplayTime(rawDateTime),
    };
};

const buildHandedAgreementMessage = (shipment) => {
    const values = buildHandedAgreementPlaceholderValues(shipment);
    const rider = values.riderName ? `Our rider ${values.riderName}` : 'Our rider';
    const contactWhen = values.date && values.time
        ? `on ${values.date} at ${values.time}`
        : values.date
            ? `on ${values.date}`
            : '';
    const contactSuffix = contactWhen
        ? `${contactWhen} via ${values.source}`
        : `via ${values.source}`;
    return `We noticed your shipment wasn't picked up, as it was verified by you over ${values.source} and handed over to another courier. ${rider} tried reaching you ${contactSuffix}. Do you agree with this?`;
};

const buildHandedAgreementFallbackOptions = (shipment) => ([
    { type: 'text', content: buildHandedAgreementMessage(shipment) },
    ...yesNoButtons(),
]);

const fetchHandedAgreementOptions = async (shipment) => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_HANDED_AGREEMENT, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildHandedAgreementFallbackOptions(shipment);
        }
        const values = buildHandedAgreementPlaceholderValues(shipment);
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: String(option.content || '')
                        .replace(/\{source\}/gi, values.source)
                        .replace(/\{riderName\}/g, values.riderName)
                        .replace(/\{SR name\}/gi, values.riderName)
                        .replace(/\{date\}/g, values.date)
                        .replace(/\{time\}/g, values.time)
                        .replace(/\{dateTime\}/g, [values.date, values.time].filter(Boolean).join(' '))
                        .replace(/\s{2,}/g, ' ')
                        .trim(),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching handed-over agreement options from MongoDB:', error);
        return buildHandedAgreementFallbackOptions(shipment);
    }
};

// Checks whether a handed-over NPR shipment is validated.
// Flowcharts: Validated via NDRNPRVerifiedSource (OTP / Call / IVR); IsAuthenticNDR also accepted.
const isValidatedHandedNpr = (shipment) => (
    hasNdrVerificationSource(shipment)
    || shipment?.isAuthenticNDR === true
    || shipment?.IsAuthenticNDR === true
);

const setHandedShipmentContext = (shipment, options = {}) => {
    const { useHandedOverSubReason = false, presetTicketIntent = true } = options;
    const isRpcancel = isHandedToOtherCourierRpcancel(shipment);
    if (presetTicketIntent) {
        if (useHandedOverSubReason) {
            // NPR row 23 — not validated enquiry ticket
            configureNprHandedNotValidatedTicket();
        } else {
            setIntentValue(isRpcancel ? '110' : '109');
            setIntentName('order-status');
            setIntentTicket('order-status-ticket');
        }
    }
    setShipmentStatus(isRpcancel ? 'RPCancel' : 'Manifestation');
    setBusinessType('reverse');
    setClientName(shipment.clientName);
    setAWBValue(shipment.poid);
    if (shipment.totalAttemptCount) {
        setAttemptCount(shipment.totalAttemptCount);
    }
    if (shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode) {
        setNDR(shipment.lastNDR || shipment.lastNDRUserProcess || shipment.ndrCode);
    }
    if (shipment.lastNDRDate || shipment.lastNDRDateTime) {
        setNDRDate(shipment.lastNDRDate || shipment.lastNDRDateTime);
    }
    setRiderName(shipment.riderName || shipment.RiderName || '');
    setNdrVerificationSource(shipment.ndrVerificationSource || shipment.NDRNPRVerifiedSource || '');
};

const buildStillHaveQueryFallbackOptions = () => ([
    { type: 'button', content: STILL_HAVE_QUERY },
    { type: 'button', content: 'Yes,I have' },
    { type: 'button', content: 'No,thanks.' },
]);

const normalizeFlowOption = (option) => {
    if (!option || typeof option !== 'object') {
        return option;
    }
    const content = option.content ?? option.context ?? option.key ?? option.text ?? '';
    return content ? { ...option, content } : option;
};

const fetchStillHaveQueryOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(STILL_HAVE_QUERY, false);
        if (Array.isArray(mongoOptions) && mongoOptions.length > 0) {
            return mongoOptions.map(normalizeFlowOption).filter((option) => (
                option?.type !== 'button' || Boolean(option.content)
            ));
        }
    } catch (error) {
        console.error('Error fetching still-have-query options from MongoDB:', error);
    }
    return buildStillHaveQueryFallbackOptions();
};

const routeHandedToOtherCourier = async (shipment) => {
    if (isValidatedHandedNpr(shipment)) {
        setHandedShipmentContext(shipment, { presetTicketIntent: false });
        setCurrentFlow(NPR_HANDED_AGREEMENT);
        return fetchHandedAgreementOptions(shipment);
    }

    // Not validated: raise enquiry ticket, show handed-over message, then still-have-query.
    setHandedShipmentContext(shipment, { useHandedOverSubReason: true });
    setCurrentFlow(NPR_HANDED_NOT_VALIDATED);
    const stillHaveOptions = await fetchStillHaveQueryOptions();
    return [
        { type: 'text', content: HANDED_OVER_MSG },
        ...stillHaveOptions,
    ];
};

const tryRouteHandedToOtherCourier = async (shipment) => {
    if (!isHandedToOtherCourierNpr(shipment)) {
        return null;
    }
    return routeHandedToOtherCourier(shipment);
};

const buildHandedCallLogOptions = async () => buildCwfdCallLogOptions();
const buildCancelledPickupCallLogOptions = async () => buildCwfdCallLogOptions();

const normalizeButtonLabel = (value) => (
    normalizeText(String(value || '').replace(/\s+/g, ' ').trim())
);

const isForwardNdrShipment = (shipment) => (
    isForwardBusinessShipment(shipment)
    && normalizeText(shipment?.latestStatus || shipment?.LatestStatus) === 'ndr'
);

const isNdrShipmentConcernsButton = (message) => {
    const normalized = normalizeButtonLabel(message).replace(/[!?.]+$/g, '').trim();
    return normalized === 'i have shipment related concerns'
        || normalized.includes('shipment related concerns')
        || normalized.includes('shipment related queries');
};

// The menu label was renamed to "...queries." in Mongo, but the child flow
// documents are still stored under the legacy "...concerns" type. Status-scoped
// labels (e.g. the RTO "...concerns!" button) keep their own types, so only the
// renamed label is remapped.
const isRenamedShipmentConcernsButton = (message) => (
    normalizeButtonLabel(message).replace(/[!?.]+$/g, '').trim() === 'i have shipment related queries'
);

const resolveShipmentConcernsMongoType = () => NDR_SHIPMENT_CONCERNS_MONGO_TYPE;

const isForwardDeliveredContext = (latestStatus = getLatestShipmentStatus()) => (
    normalizeText(latestStatus) === 'delivered'
);

const isDeliveredShipmentConcernsButton = (message) => (
    isNdrShipmentConcernsButton(message) && isForwardDeliveredContext()
);

const isDeliveredNotReceivedButton = (message) => {
    const normalized = stripTrailingPeriod(message);
    return normalized === stripTrailingPeriod(DELIVERED_NOT_RECEIVED);
};

const isDeliveredIncorrectShipmentButton = (message) => {
    const normalized = normalizeButtonLabel(message).toLowerCase();
    return normalized.startsWith('i have received an incorrect shipment')
        || normalized === 'i have received incorrect shipment'
        || (normalized.includes('incorrect shipment') && isForwardDeliveredContext());
};

const isDeliveredNotReceivedAgreementContext = (flow = getCurrentFlow()) => (
    flow === DELIVERED_NOT_RECEIVED
    || flow === DELIVERED_NOT_RECEIVED_AGREEMENT
);

const stripTrailingPeriod = (value) => normalizeButtonLabel(value).replace(/\.$/, '');

const isUpdateContactDetailsButton = (message) => (
    stripTrailingPeriod(message) === stripTrailingPeriod(UPDATE_CONTACT_DETAILS_MENU)
);

const isUpdateContactDetailsContext = (flow = getCurrentFlow()) => (
    stripTrailingPeriod(flow) === stripTrailingPeriod(UPDATE_CONTACT_DETAILS_MENU)
);

const isUpdateAlternateContactButton = (message) => {
    const normalized = stripTrailingPeriod(message);
    return normalized === stripTrailingPeriod(UPDATE_ALTERNATE_CONTACT_BUTTON)
        || normalized === stripTrailingPeriod(UPDATE_ALTERNATE_CONTACT);
};

const isUpdateAddressButton = (message) => (
    stripTrailingPeriod(message) === stripTrailingPeriod(UPDATE_CONTACT_ADDRESS)
);

const isNdrSpecialFlowTrigger = (message) => {
    const normalized = normalizeButtonLabel(message);
    return normalized === 'where is my shipment?'
        || normalized === 'where is my shipment'
        // NPR hub button renamed in Mongo: "Where is my shipment" → "What is my pickup status".
        || normalized === 'what is my pickup status'
        || normalized === 'what is my pickup status?'
        || normalized === 'what is my pick up status'
        || normalized === 'what is my pick up status?';
};

const isNdrShipmentConcernsContext = (flow = getCurrentFlow()) => {
    const normalized = normalizeButtonLabel(flow);
    const isDynamicNdrConcernsType = normalized.startsWith('ndr.concerns.');
    return flow === NDR_SHIPMENT_CONCERNS_MENU
        || normalized === normalizeButtonLabel(NDR_SHIPMENT_CONCERNS_MONGO_TYPE)
        || normalized === normalizeButtonLabel(SHIPMENT_CONCERNS_BUTTON)
        || isDynamicNdrConcernsType;
};

const isNprShipmentConcernsContext = (flow = getCurrentFlow()) => (
    flow === NPR_SHIPMENT_CONCERNS_MENU
    || normalizeButtonLabel(flow) === normalizeButtonLabel(NPR_SHIPMENT_CONCERNS_MONGO_TYPE)
);

const isPendingPickupContext = () => {
    const latestStatus = normalizeText(getLatestShipmentStatus() || '').replace(/\s+/g, '_');
    return latestStatus === 'pending_for_pickup' || latestStatus === 'npr_pickup_not_done';
};

const isNprShipmentRelatedConcernButton = (message) => (
    normalizeButtonLabel(message).replace(/[!?.]+$/g, '').trim()
    === normalizeButtonLabel(NPR_SHIPMENT_CONCERNS_MONGO_TYPE)
);

const isReschedulePickupButton = (message) => (
    normalizeButtonLabel(message) === normalizeButtonLabel(RESCHEDULE_PICKUP)
);

const isReversePickupHubContext = () => (
    isPendingPickupContext()
    || isReverseNprUserContext()
    || isNprShipmentConcernsContext()
    || isNprConcernsActive()
);

const isReverseNprUserContext = () => {
    const snapshot = getNprShipmentSnapshot();
    if (snapshot && isReverseBusinessShipment(normalizeShipmentSnapshot(snapshot))) {
        return isNprSpecialFlowLatestStatus(snapshot);
    }
    // === REMOVE_BEFORE_GO_LIVE: require latestStatus=npr|npr_pickup_not_done + reverse ===
    const latestStatus = normalizeText(getLatestShipmentStatus());
    if (latestStatus !== 'npr' && latestStatus !== 'npr_pickup_not_done') {
        return false;
    }
    return normalizeText(getBusinessType() || '') === 'reverse';
    // === END REMOVE_BEFORE_GO_LIVE ===
};

const mapMongoFlowOptions = (mongoOptions) => (
    (Array.isArray(mongoOptions) ? mongoOptions : [])
        .map((option) => {
            if (!option || typeof option !== 'object') {
                return option;
            }
            const content = option.content ?? option.context ?? option.key ?? option.text ?? '';
            return content ? { ...option, content } : option;
        })
        .filter((option) => option?.type !== 'button' || Boolean(option.content))
);

const applyReversePickupSnapshot = (normalized, status) => {
    const snapshot = { ...normalized, latestStatus: status };
    setNprShipmentSnapshot(snapshot);
    if (snapshot.poid) {
        setAWBValue(snapshot.poid);
    }
    setBusinessType(snapshot.businessType || 'reverse');
    setLatestShipmentStatus(status);
    if (snapshot.clientName) {
        setClientName(snapshot.clientName);
    }
    if (snapshot.totalAttemptCount != null) {
        setAttemptCount(snapshot.totalAttemptCount);
    }
    const primaryNdrReason = getPrimaryNdrReason(snapshot);
    if (primaryNdrReason) {
        setNDR(primaryNdrReason);
        setNDRDate(snapshot.lastNDRDate || snapshot.lastNDRDateTime || '');
    }
    setNdrVerificationSource(
        snapshot.ndrVerificationSource || snapshot.NDRNPRVerifiedSource || ''
    );
    setRiderName(snapshot.riderName || snapshot.RiderName || '');
};

const applyOtpShipmentSnapshot = (snapshot, latestStatus) => {
    if (!snapshot) {
        return;
    }
    const normalized = normalizeShipmentSnapshot(snapshot);
    const status = normalizeText(latestStatus || normalized.latestStatus);
    if (status === 'ndr') {
        setForwardNdrShipmentContext(normalized);
        return;
    }
    if (status === 'rpcancel') {
        applyReversePickupSnapshot(normalized, 'rpcancel');
        setShipmentStatus('RPCancel');
        setIntentName('order-status');
        setIntentTicket('order-status-ticket');
        setIntentValue('110');
        return;
    }
    // === REMOVE_BEFORE_GO_LIVE: NPR snapshot only for LatestStatus=npr ===
    if (status === 'npr' || status === 'npr_pickup_not_done') {
        applyReversePickupSnapshot(normalized, status === 'npr_pickup_not_done' ? status : 'npr');
    }
    // === END REMOVE_BEFORE_GO_LIVE ===
};

const setForwardNdrShipmentContext = (shipment) => {
    const snapshot = normalizeShipmentSnapshot(shipment);
    setNdrShipmentSnapshot(snapshot);
    setAWBValue(snapshot.poid);
    setBusinessType(snapshot.businessType || 'forward');
    setClientName(snapshot.clientName);
    setShipmentStatus('Inscan');
    setIntentValue('106');
    setIntentName('order-status');
    setIntentTicket('order-status-ticket');
    if (snapshot.totalAttemptCount != null) {
        setAttemptCount(snapshot.totalAttemptCount);
    }
    const reattemptRaw = getShipmentReattemptDate(snapshot);
    if (reattemptRaw) {
        setReattemptDate(String(reattemptRaw).split(' ')[0]);
    }
    const primaryNdrReason = getPrimaryNdrReason(snapshot);
    if (primaryNdrReason) {
        setNDR(primaryNdrReason);
        setNDRDate(snapshot.lastNDRDate || snapshot.lastNDRDateTime || '');
    }
    if (normalizeText(snapshot.order_type) === 'prepaid') {
        setShipmentType('prepaid');
    } else {
        setShipmentType('cod');
    }
    if (snapshot.orderPDD) {
        setEDD(String(snapshot.orderPDD).split(' ')[0]);
    } else if (snapshot.orderEDD) {
        setEDD(String(snapshot.orderEDD).split(' ')[0]);
    }
    setCurrentFlow(NDR_ENQUIRY_MONGO_TYPE);
};

const NDR_MONGO_OPTIONS_ERROR = 'Sorry, we could not load options right now. Please try again.';

const buildNdrConcernsShipmentContext = () => {
    const existing = getNdrShipmentSnapshot();
    if (existing?.poid) {
        return normalizeShipmentSnapshot(existing);
    }

    return normalizeShipmentSnapshot({
        poid: getAWBValue(),
        latestStatus: getLatestShipmentStatus() || 'ndr',
        businessType: 'forward',
        totalAttemptCount: Number(getAttemptCount() || 0),
        lastNDRDate: getNDRDate(),
        lastNDRDateTime: getNDRDate(),
    });
};

// Resolves the NDR shipment-concerns flow type from CRA reason (only),
// attempt count, and whether the shipment is at the last-mile facility.
// CNA / CWFD fall through to default / no_attempt menus.
const resolveNdrConcernsMongoType = (shipment, isShipmentAtLM = false) => {
    const snapshot = normalizeShipmentSnapshot(shipment || {});
    const attempts = Number(snapshot.totalAttemptCount || 0);
    const lmSuffix = isShipmentAtLM ? 'lm' : 'non_lm';

    if (isCraReasonForConcernsMenu(snapshot)) {
        return `ndr.concerns.customer_refuse.${lmSuffix}`;
    }
    if (attempts >= 1 && attempts <= 2) {
        return `ndr.concerns.default.${lmSuffix}`;
    }
    return `ndr.concerns.no_attempt.${lmSuffix}`;
};

const isNdrCancelConcernOption = (option) => {
    const label = normalizeButtonLabel(option?.content ?? option?.key ?? option?.text ?? '');
    return label.includes('cancel my shipment') || label.includes('cancel shipment');
};

const filterNdrConcernsMenuOptions = (snapshot, options) => {
    if (!isCraReasonForConcernsMenu(snapshot)) {
        return options;
    }
    return (Array.isArray(options) ? options : []).filter((option) => !isNdrCancelConcernOption(option));
};

const isForwardNdrUserContext = () => {
    const snapshot = getNdrShipmentSnapshot();
    if (snapshot && isForwardNdrShipment(normalizeShipmentSnapshot(snapshot))) {
        return true;
    }
    return normalizeText(getLatestShipmentStatus()) === 'ndr';
};

const fetchNdrEnquiryMenuOptions = async () => {
    try {
        const mongoOptions = await fetchOptionsOfInput(NDR_ENQUIRY_MONGO_TYPE, false);
        if (Array.isArray(mongoOptions) && mongoOptions.length > 0) {
            return mapMongoFlowOptions(mongoOptions);
        }
    } catch (error) {
        console.error('Error fetching NDR enquiry menu from MongoDB:', error);
    }
    return NDR_MONGO_OPTIONS_ERROR;
};

const fetchUpdateContactDetailsMenuOptions = async () => {
    setCurrentFlow(UPDATE_CONTACT_DETAILS_MENU);
    try {
        const mongoOptions = await fetchOptionsOfInput(UPDATE_CONTACT_DETAILS_MENU, false);
        if (Array.isArray(mongoOptions) && mongoOptions.length > 0) {
            return mapMongoFlowOptions(mongoOptions);
        }
    } catch (error) {
        console.error('Error fetching update contact details menu from MongoDB:', error);
    }
    return NDR_MONGO_OPTIONS_ERROR;
};

const prepareNdrContactDetailsChildFlow = (message) => {
        if (isUpdateAlternateContactButton(message)) {
        clearAltMobileOtpState();
        setIntentName('update-contact-number');
        setIntentTicket('update-contact-number-yes');
        setCurrentFlow(UPDATE_ALTERNATE_CONTACT);
        // Clear stale address-update state so typed input is treated as a
        // mobile number, not a pincode.
        setAddressUpdateStep('');
        return true;
    }
    if (isUpdateAddressButton(message)) {
        setIntentName('update-contact-address');
        setIntentTicket('update-contact-address-yes');
        setCurrentFlow(UPDATE_CONTACT_ADDRESS);
        setAddressUpdateStep('pincode');
        return true;
    }
    return false;
};

const isNdrCancelShipmentButton = (message) => isNdrCancelConcernOption({ content: message });

const isNdrRescheduleShipmentButton = (message) => {
    const label = normalizeButtonLabel(message);
    return label.includes('reschedule my shipment');
};

const resolveCancelShipmentMongoType = () => CANCEL_ORDER;

const resolveRescheduleShipmentMongoType = () => RESCHEDULE_SHIPMENT;

const isNdrSelfCollectShipmentButton = (message) => {
    const label = normalizeButtonLabel(message);
    return label.includes('self collect my shipment') || label.includes('self collect my order');
};

const resolveSelfCollectShipmentMongoType = () => SELF_COLLECT_SHIPMENT;

const interpolateCancelShipmentTemplate = (template, awb) => {
    const shipmentId = String(awb || '').trim();
    return String(template || '')
        .replace(/\[Number\]/gi, shipmentId)
        .replace(/\[AWB\]/gi, shipmentId)
        .replace(/\{AWB\}/gi, shipmentId)
        .replace(/\s{2,}/g, ' ')
        .trim();
};

const buildCancelShipmentConfirmationFallbackOptions = (awb) => ([
    {
        type: 'text',
        content: interpolateCancelShipmentTemplate(
            "We noticed you'd like to cancel your shipment with AWB [Number]. Please confirm would you like to proceed with the cancellation?",
            awb,
        ),
    },
    { type: 'button', content: 'Yes' },
    { type: 'button', content: 'No' },
]);

const fetchCancelShipmentConfirmationOptions = async () => {
    const awb = getAWBValue() || getNumber();
    try {
        const mongoOptions = await fetchOptionsOfInput(CANCEL_ORDER, false);
        if (!Array.isArray(mongoOptions) || mongoOptions.length === 0) {
            return buildCancelShipmentConfirmationFallbackOptions(awb);
        }
        return mongoOptions.map((option) => {
            if (option?.type === 'text' && option.content) {
                return {
                    ...option,
                    content: interpolateCancelShipmentTemplate(option.content, awb),
                };
            }
            return option;
        });
    } catch (error) {
        console.error('Error fetching cancel shipment confirmation options:', error);
        return buildCancelShipmentConfirmationFallbackOptions(awb);
    }
};

const prepareNdrShipmentConcernsChildFlow = (message) => {
    if (isNdrCancelShipmentButton(message)) {
        setIntentName('cancel-order');
        setIntentTicket('cancel-order-yes');
        setCurrentFlow(CANCEL_ORDER);
        return {
            fetchType: resolveCancelShipmentMongoType(),
            awaitingCancelConfirm: true,
        };
    }
    if (isNdrRescheduleShipmentButton(message)) {
        setIntentName('update-delivery-date');
        setIntentTicket('update-delivery-date-yes');
        setCurrentFlow(RESCHEDULE_SHIPMENT);
        return {
            fetchType: resolveRescheduleShipmentMongoType(),
            appendDeliveryDates: true,
        };
    }
    if (isNdrSelfCollectShipmentButton(message)) {
        setIntentName('update-selfCollect-date');
        setIntentTicket('update-selfCollect-date-yes');
        setIntentValue('26');
        setCurrentFlow(SELF_COLLECT_SHIPMENT);
        return {
            fetchType: resolveSelfCollectShipmentMongoType(),
            appendDeliveryDates: true,
            selfCollect: true,
        };
    }
    return null;
};

const filterDeliveredConcernsMenuOptions = (options) => {
    if (!Array.isArray(options) || options.length === 0) {
        return null;
    }
    const allowed = [];
    options.forEach((option) => {
        if (!option || option.type !== 'button' || !option.content) {
            return;
        }
        const label = normalizeButtonLabel(option.content).toLowerCase();
        if (label.includes('wrong') && label.includes('damaged')) {
            return;
        }
        if (label.startsWith('i have not received my shipment')) {
            allowed.push({ ...option, content: DELIVERED_NOT_RECEIVED });
        } else if (label.includes('incorrect shipment')) {
            allowed.push(option);
        }
    });
    return allowed.length >= 2 ? allowed.slice(0, 2) : null;
};

const buildDeliveredShipmentConcernsFallbackOptions = (awb, recipient) => {
    const awbLabel = String(awb || 'AWB number').trim();
    const recipientLabel = String(recipient || '').trim();
    return [
        { type: 'button', content: DELIVERED_NOT_RECEIVED },
        {
            type: 'button',
            content: (
                `${DELIVERED_INCORRECT_SHIPMENT_PREFIX} ${awbLabel}${recipientLabel ? ` / ${recipientLabel}` : ''} `
                + 'does not match with my order'
            )
,
        },
    ];
};

const fetchDeliveredShipmentConcernsMenuOptions = async () => {
    setCurrentFlow(DELIVERED_SHIPMENT_CONCERNS_MENU);
    const fallback = buildDeliveredShipmentConcernsFallbackOptions(getAWBValue());

    if (!DELIVERED_USE_MONGO_MENUS) {
        return fallback;
    }

    try {
        const mongoOptions = await fetchOptionsOfInput(DELIVERED_SHIPMENT_CONCERNS_MONGO_TYPE, false);
        const filtered = filterDeliveredConcernsMenuOptions(
            Array.isArray(mongoOptions)
                ? mongoOptions.map(normalizeFlowOption)
                : null,
        );
        if (filtered) {
            return filtered;
        }
    } catch (error) {
        console.error('Error fetching delivered shipment concerns menu from MongoDB:', error);
    }
    return fallback;
};

const fetchNprShipmentConcernsMenuOptions = async () => {
    setCurrentFlow(NPR_SHIPMENT_CONCERNS_MENU);
    try {
        const mongoOptions = await fetchOptionsOfInput(NPR_SHIPMENT_CONCERNS_MONGO_TYPE, false);
        if (Array.isArray(mongoOptions) && mongoOptions.length > 0) {
            return mapMongoFlowOptions(mongoOptions);
        }
    } catch (error) {
        console.error('Error fetching NPR shipment concerns menu from MongoDB:', error);
    }
    return NDR_MONGO_OPTIONS_ERROR;
};

const fetchNdrShipmentConcernsMenuOptions = async () => {
    const { hydrateForwardNdrShipmentContext } = require('./OptionsHandler');
    if (getAWBValue() && getIsOTPValidated() === 'true') {
        await hydrateForwardNdrShipmentContext(getAWBValue());
    }
    let snapshot = normalizeShipmentSnapshot(getNdrShipmentSnapshot());
    if (!snapshot?.poid && getAWBValue()) {
        const hydrated = getNdrShipmentSnapshot();
        if (hydrated) {
            snapshot = normalizeShipmentSnapshot(hydrated);
        }
    }
    if (!snapshot?.poid) {
        snapshot = buildNdrConcernsShipmentContext();
    }
    // Shipment is at LM facility when CurrentHubID === FinalDestinationID.
    const isShipmentAtLM = isShipmentAtLastMile(snapshot);
    const concernType = resolveNdrConcernsMongoType(snapshot, isShipmentAtLM);
    setCurrentFlow(concernType);
    try {
        let mongoOptions = await fetchOptionsOfInput(concernType, false);
        if (Array.isArray(mongoOptions) && mongoOptions.length > 0) {
            return filterNdrConcernsMenuOptions(snapshot, mapMongoFlowOptions(mongoOptions));
        }
    } catch (error) {
        console.error('Error fetching NDR shipment concerns menu from MongoDB:', error);
    }
    return NDR_MONGO_OPTIONS_ERROR;
};

const runFirstMatchingFlow = async (shipment, flowHandlers = []) => {
    for (const handler of flowHandlers) {
        const response = await handler(shipment);
        if (response) {
            return response;
        }
    }
    return null;
};

const routeForwardNdrSpecialFlows = async (shipment) => {
    const normalized = normalizeShipmentSnapshot(shipment);
    setNdrConcernsActive(false);
    const flowResponse = await runFirstMatchingFlow(normalized, [
        tryRouteNdrPaymentCouldNotBeCompleted,
        tryRouteAddressIncompleteNdr,
        tryRouteCwfdCnaNdr,
        tryRouteCraNdr,
    ]);
    if (flowResponse) {
        return flowResponse;
    }
    return `The shipment with ID ${normalized.poid} is currently under process. Thank you for your patience and understanding!`;
};

// Mirrors routeForwardNdrSpecialFlows for reverse LatestStatus=npr (and rpcancel).
const routeRpcancelSpecialFlows = async (shipment) => {
    const normalized = normalizeShipmentSnapshot(shipment);
    if (!normalized || !isReverseBusinessShipment(normalized) || !isRpcancelShipment(normalized)) {
        return null;
    }
    setNprConcernsActive(false);
    if (isHandedToOtherCourierReason(normalized)) {
        return tryRouteHandedToOtherCourier(normalized);
    }
    return runFirstMatchingFlow(normalized, [
        tryRouteAddressIncompleteNpr,
        tryRouteRefundReplacementFirst,
        tryRouteCancelledPickupRpcancel,
        tryRouteCustomerWantsFuturePickupNpr,
    ]);
};

const routeReverseNprSpecialFlows = async (shipment) => {
    const normalized = normalizeShipmentSnapshot(shipment);
    if (!normalized || !isReverseBusinessShipment(normalized)) {
        return null;
    }
    if (isRpcancelShipment(normalized)) {
        return routeRpcancelSpecialFlows(normalized);
    }
    setNprConcernsActive(false);
    return runFirstMatchingFlow(normalized, [
        tryRouteAddressIncompleteNpr,
        tryRouteRefundReplacementFirst,
        tryRouteCancelledPickupRpcancel,
        tryRouteHandedToOtherCourier,
        // OFP/CNA (Customer not available) is handled by backend
        // npr_pickup_not_done_flow → pickup_cancelled_ofp_cna_flow via fetch-records.
        // CWFP last: process-code heuristics must not beat explicit NPR reasons.
        tryRouteCustomerWantsFuturePickupNpr,
    ]);
};

const tryShowForwardNdrEnquiryMenu = async (shipment) => {
    if (!isForwardNdrShipment(shipment)) {
        return null;
    }
    setForwardNdrShipmentContext(shipment);
    setCurrentFlow(NDR_ENQUIRY_MENU);
    return fetchNdrEnquiryMenuOptions();
};

const handleNdrEnquiryButtonClick = async (message) => {
    if (!isNdrSpecialFlowTrigger(message)) {
        return null;
    }

    const shipment = normalizeShipmentSnapshot(getNdrShipmentSnapshot());
    if (!shipment || (!isNdrShipmentConcernsContext() && !isNdrConcernsActive())) {
        return null;
    }

    return routeForwardNdrSpecialFlows(shipment);
};

const isNdrEnquirySessionFlow = (flow = getCurrentFlow()) => (
    flow === NDR_ENQUIRY_MENU
    || flow === NDR_ENQUIRY_MONGO_TYPE
    || isNdrShipmentConcernsContext(flow)
    || isUpdateContactDetailsContext(flow)
);

export {
    isAddressIncompleteNdr,
    isValidatedAdiNdr,
    routeAddressIncompleteNdr,
    tryRouteAddressIncompleteNdr,
    continueAdiFlowAfterAddressUpdate,
    ADDRESS_INCOMPLETE_NPR_MSG,
    NPR_ADI_ADDRESS_UPDATED_MSG,
    NPR_ADI_AGREE_THANKS,
    buildAdiCallLogOptions,
    ADI_AGREEMENT_PROMPT,
    NDR_ADI_AGREEMENT,
    NDR_ADI_CALL_LOG,
    NDR_ADI_REATTEMPT,
    NDR_ADI_REATTEMPT_DELAY,
    NDR_ADI_FLOW_END,
    isAddressIncompleteNpr,
    isValidatedAdiNpr,
    routeAddressIncompleteNpr,
    tryRouteAddressIncompleteNpr,
    continueNprAdiFlowAfterAddressUpdate,
    buildNprAdiCallLogOptions,
    configureNprAdiDisagreeTicket,
    NPR_ADI_AGREEMENT,
    NPR_ADI_CALL_LOG,
    NPR_ADI_REATTEMPT,
    NPR_ADI_FLOW_END,
    isCwfdOrCnaNdr,
    matchesCwfdCnaNdrReason,
    isValidatedCwfdCnaNdr,
    routeCwfdCnaNdr,
    tryRouteCwfdCnaNdr,
    buildCwfdCallLogOptions,
    buildCwfdAgreementMessage,
    configureNdrAgreementYesTicket,
    configureRpcancelPickupAgreementYesTicket,
    configureRpcancelPickupDisagreeTicket,
    configureDeliveredAgreementYesTicket,
    configureDeliveredIncorrectShipmentTicket,
    configureNprHandedDisagreeTicket,
    configureNprHandedNotValidatedTicket,
    NDR_CWFD_AGREEMENT,
    NDR_CWFD_CALL_LOG,
    NDR_CWFD_REATTEMPT,
    NDR_CWFD_REATTEMPT_DELAY,
    NDR_CWFD_MAX_ATTEMPTS,
    NDR_CWFD_FLOW_END,
    CWFD_AGREE_THANKS,
    CWFD_CALL_LOG_PROMPT,
    isCraNdr,
    isValidatedCraNdr,
    routeCraNdr,
    tryRouteCraNdr,
    buildCraAgreementMessage,
    buildCraCallLogOptions,
    NDR_CRA_AGREEMENT,
    NDR_CRA_CALL_LOG,
    NDR_CRA_REATTEMPT,
    NDR_CRA_REATTEMPT_DELAY,
    NDR_CRA_MAX_ATTEMPTS,
    NDR_CRA_FLOW_END,
    isNdrPaymentCouldNotBeCompleted,
    routeNdrPaymentCouldNotBeCompleted,
    tryRouteNdrPaymentCouldNotBeCompleted,
    NDR_PNC_MAX_ATTEMPTS,
    NDR_PNC_REATTEMPT,
    NDR_PNC_REATTEMPT_DELAY,
    NDR_PNC_RESCHEDULE,
    NDR_PNC_DATE_SELECTION,
    NDR_PNC_FLOW_END,
    PNC_SELECT_DATE_PROMPT,
    PNC_NO_CHANGES_MSG,
    NPR_RESCHEDULE_PICKUP,
    NPR_PICKUP_DATE_SELECTION,
    fetchRefundPickupDateOptions,
    isRefundReplacementFirstRpcancel,
    isRpcancelShipment,
    routeRefundReplacementFirst,
    tryRouteRefundReplacementFirst,
    isRefundReplacementFirstNpr,
    isRefundReplacementFirstShipment,
    RPCANCEL_REFUND_MAX_ATTEMPTS,
    RPCANCEL_REFUND_REATTEMPT,
    RPCANCEL_REFUND_RESCHEDULE,
    RPCANCEL_REFUND_DATE_SELECTION,
    RPCANCEL_REFUND_FLOW_END,
    RPCANCEL_REFUND_SELECT_DATE_PROMPT,
    RPCANCEL_REFUND_NO_CHANGES_MSG,
    isCustomerWantsFuturePickupNpr,
    isValidatedCustomerWantsFuturePickupNpr,
    routeCustomerWantsFuturePickupNpr,
    tryRouteCustomerWantsFuturePickupNpr,
    buildCwfpAgreementMessage,
    NPR_CWFP_AGREEMENT,
    NPR_CWFP_CALL_LOG,
    NPR_CWFP_REATTEMPT,
    NPR_CWFP_FLOW_END,
    NPR_PICKUP_WHERE_IS_LABEL,
    isCancelledPickupReason,
    isCancelledPickupRpcancel,
    isValidatedCancelledPickupRpcancel,
    routeCancelledPickupRpcancel,
    tryRouteCancelledPickupRpcancel,
    buildCancelledPickupAgreementMessage,
    buildCancelledPickupCallLogOptions,
    RPCANCEL_PICKUP_AGREEMENT,
    RPCANCEL_PICKUP_CALL_LOG,
    RPCANCEL_PICKUP_REATTEMPT,
    RPCANCEL_PICKUP_MAX_ATTEMPTS,
    RPCANCEL_PICKUP_FLOW_END,
    isHandedToOtherCourierNpr,
    isValidatedHandedNpr,
    isNprSpecialFlowLatestStatus,
    routeHandedToOtherCourier,
    tryRouteHandedToOtherCourier,
    buildHandedAgreementMessage,
    buildHandedCallLogOptions,
    fetchStillHaveQueryOptions,
    NPR_HANDED_AGREEMENT,
    NPR_HANDED_CALL_LOG,
    NPR_HANDED_NOT_VALIDATED,
    NPR_HANDED_FLOW_END,
    STILL_HAVE_QUERY,
    HANDED_OVER_MSG,
    isForwardNdrShipment,
    normalizeShipmentSnapshot,
    applyOtpShipmentSnapshot,
    fetchNdrEnquiryMenuOptions,
    fetchDeliveredShipmentConcernsMenuOptions,
    buildDeliveredShipmentConcernsFallbackOptions,
    filterDeliveredConcernsMenuOptions,
    fetchNdrShipmentConcernsMenuOptions,
    fetchNprShipmentConcernsMenuOptions,
    isReverseNprUserContext,
    isNprShipmentConcernsContext,
    isNprShipmentRelatedConcernButton,
    isReschedulePickupButton,
    isReversePickupHubContext,
    fetchUpdateContactDetailsMenuOptions,
    isUpdateContactDetailsButton,
    prepareNdrContactDetailsChildFlow,
    prepareNdrShipmentConcernsChildFlow,
    isNdrCancelShipmentButton,
    isNdrRescheduleShipmentButton,
    isNdrSelfCollectShipmentButton,
    resolveCancelShipmentMongoType,
    resolveRescheduleShipmentMongoType,
    resolveSelfCollectShipmentMongoType,
    isRenamedShipmentConcernsButton,
    resolveShipmentConcernsMongoType,
    fetchCancelShipmentConfirmationOptions,
    interpolateCancelShipmentTemplate,
    resolveNdrConcernsMongoType,
    filterNdrConcernsMenuOptions,
    isCraReason,
    buildNdrConcernsShipmentContext,
    isForwardNdrUserContext,
    routeForwardNdrSpecialFlows,
    routeReverseNprSpecialFlows,
    routeRpcancelSpecialFlows,
    handleNdrEnquiryButtonClick,
    isNdrEnquirySessionFlow,
    isNdrSpecialFlowTrigger,
    isNdrShipmentConcernsButton,
    isForwardDeliveredContext,
    isDeliveredShipmentConcernsButton,
    isDeliveredNotReceivedButton,
    isDeliveredIncorrectShipmentButton,
    isDeliveredNotReceivedAgreementContext,
    isNdrShipmentConcernsContext,
    DELIVERED_NOT_RECEIVED,
    DELIVERED_NOT_RECEIVED_AGREEMENT,
    DELIVERED_INCORRECT_SHIPMENT_FLOW,
    DELIVERED_FLOW_END,
    DELIVERED_SHIPMENT_CONCERNS_MENU,
    NDR_ENQUIRY_MENU,
    NDR_SHIPMENT_CONCERNS_MENU,
};

// #enhancements_pxb5559 changes done according workflow enhancements
const getCurrentDate = () => {
    let date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return new Date(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`);
}
// #enhancements_pxb5559 changes done according workflow enhancements
const getFutureDate = () => {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}

const convertToISODate = (dateString) => {
    const [d, m, y, time] = dateString.replace(' ', '-').split('-');
    return new Date(`${y}-${m}-${d} ${time}`);
}

async function appendResponse(data) {
    try {
        // #enhancements_pxb5559 changes done according workflow enhancements
        let dateTime = getCurrentDate();
        let type = "";
        let pddDate, eddDate;
        for (let product = 0; product < data.length; product++) {
            // #features_pxb5559 changes done for future pickup
            if (data[product].businessType == "forward" && (getIntentName() == 'complaint-raise-wrong-picked' || getIntentName() == 'complaint-raise-not-picked' || getIntentName() == 'update-pickup-date')) {
                return `${data[product].poid} is not a return request. Please select appropriate option.`;
            } else if (data[product].businessType == "reverse" && (getIntentName() == 'complaint-raise-not-received' || getIntentName() == 'update-delivery-date' || getIntentName() == 'complaint-raise-charged-extra')) {
                return `${data[product].poid} is not a delivery request. Please select appropriate option.`
            } else if (normalizeText(data[product].businessType) === 'forward'
                || (matchesCwfdCnaNdrReason(data[product]) && !isReverseBusinessShipment(data[product]))) {
                // #enhancements_pxb5559 changes done according workflow enhancements
                setBusinessType("forward");
                const ndrEnquiryMenu = await tryShowForwardNdrEnquiryMenu(data[product]);
                if (ndrEnquiryMenu) {
                    return ndrEnquiryMenu;
                }
                const cwfdEarlyResponse = await tryRouteCwfdCnaNdr(data[product]);
                if (cwfdEarlyResponse) {
                    return cwfdEarlyResponse;
                }
                const pncEarlyResponse = await tryRouteNdrPaymentCouldNotBeCompleted(data[product]);
                if (pncEarlyResponse) {
                    return pncEarlyResponse;
                }
                if (data[product].orderEDD != 'None' && data[product].orderEDD != null) {
                    eddDate= convertToISODate(data[product].orderEDD);
                    data[product].orderEDD = data[product].orderEDD.split(" ")[0];
                    setEDD(data[product].orderEDD);
                }
                if (data[product].orderPDD != 'None' && data[product].orderPDD != null) {
                    pddDate = convertToISODate(data[product].orderPDD);
                    data[product].orderPDD = data[product].orderPDD.split(" ")[0];
                    setEDD(data[product].orderPDD);
                }
                if (data[product].order_type == "prepaid") {
                    setShipmentType("prepaid");
                    type = data[product].order_type;
                } else {
                    setShipmentType("cod");
                    type = data[product].order_type + " of Rs. " + data[product].orderAmount;
                }
                if (data[product].totalAttemptCount) {
                    setAttemptCount(data[product].totalAttemptCount);
                }
                // #enhancements_pxb5559 changes done according workflow enhancements
                if (data[product].reattemptDate != 'None' && data[product].reattemptDate != null) {
                    data[product].reattemptDate = data[product].reattemptDate.split(" ")[0];
                    setReattemptDate(data[product].reattemptDate);
                }
                if (data[product].ndrCode) {
                    setNDR(data[product].ndrCode);
                    setNDRDate(data[product].lastNDRDate || data[product].lastNDRDateTime || '');
                }
                if (data[product].status == 'Pending') {
                    setIntentValue("108");
                    setShipmentStatus("Manifestation");
                    setClientName(data[product].clientName);
                    return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We will be able to confirm its estimated delivery date once it has been picked up from the vendor or warehouse. I kindly request you to check back after some time for an updated status. Thank you for your patience!";
                } else if ((data[product].orderEDD == null || data[product].orderEDD == 'None') && (data[product].orderPDD == null || data[product].orderPDD == 'None')) {
                    setIntentValue("105");
                    setShipmentStatus("Inscan");
                    setClientName(data[product].clientName);
                    const cwfdResponse = await tryRouteCwfdCnaNdr(data[product]);
                    if (cwfdResponse) {
                        return cwfdResponse;
                    }
                    const craResponse = await tryRouteCraNdr(data[product]);
                    if (craResponse) {
                        return craResponse;
                    }
                    const adiResponse = await tryRouteAddressIncompleteNdr(data[product]);
                    if (adiResponse) {
                        return adiResponse;
                    }
                    const pncResponse = await tryRouteNdrPaymentCouldNotBeCompleted(data[product]);
                    if (pncResponse) {
                        return pncResponse;
                    }
                    if (data[product].status == 'Shipped' && data[product].notificationType == 'RTO' && data[product].orderStatus == 'InScan' && data[product].ndrCode == 'Out for Delivery') {
                        setShipmentStatus("OFD");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. Currently, it is in transit and has not reached its destination yet. We will try to deliver it ASAP."
                    }

                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && data[product].ndrCode == 'Out for Delivery') {
                        setShipmentStatus("OFD");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". It is out for delivery today. Our service representative will contact you shortly to ensure smooth delivery."
                    }
                    else if (data[product].status === 'Shipped' && data[product].orderStatus === 'InScan' && data[product].notificationType === 'CSAW' && data[product].notificationStatus === "Pending" && data[product].totalAttemptCount >= 1) {
                        // V NDR
                        return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. We were unable to deliver it due to ${data[product].ndrCode} on ${data[product].lastNDRDate}. We are currently awaiting further instructions from the client. Once we receive the updated date of delivery, we will process the request and ensure it is delivered as soon as possible. Thank you for your patience and understanding!`;
                    }
                    else if (data[product].status === 'Shipped' && data[product].orderStatus === 'InScan' && normalizeText(data[product].notificationStatus) === 'reattempt' && data[product].totalAttemptCount >= 1) {
                        const cwfdReattemptResponse = await tryRouteCwfdCnaNdr(data[product]);
                        if (cwfdReattemptResponse) {
                            return cwfdReattemptResponse;
                        }
                        const cwfdFallback = await routeCwfdCnaIfNdrReasonMatches(data[product]);
                        if (cwfdFallback) {
                            return cwfdFallback;
                        }
                        // UN NDR
                        return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. We were unable to deliver it due to ${data[product].ndrCode} on ${data[product].lastNDRDate}. We will reattempt delivery on ${getFutureDate()}. Thank you for your patience and understanding!`;
                    }

                    else if (data[product].status == 'Shipped' && data[product].notificationType == 'RTO') {
                        if (data[product].totalAttemptCount >= 1) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly."
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly."
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus != 'InScan') {
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Currently it is in transit and has not reached destination. We will try to deliver it as soon as possible. You will be notified by SMS and a phone call once it is out for delivery."

                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && data[product].totalAttemptCount >= 1) {
                        const cwfdBeforeGeneric = await tryRouteCwfdCnaNdr(data[product]);
                        if (cwfdBeforeGeneric) {
                            return cwfdBeforeGeneric;
                        }

                        if (data[product].reattemptDate != 'None' && data[product].reattemptDate != null) {
                            let reattemptDate = data[product].reattemptDate.split(' ')[0]
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". We will reattempt to deliver it by " + reattemptDate + "."
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + "."

                        }
                    }
                    // #enhancements_pxb5559 changes done according workflow enhancements
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null) && (data[product].originHubID === data[product].currentHubID && data[product].currentHubID === data[product].finalHubID)) {
                        setIntentValue("1");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName  + ". It has already reached its destination. We will make every effort to deliver it ASAP.";
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null) && (data[product].originHubID !== data[product].currentHubID && data[product].currentHubID !== data[product].finalHubID)) {
                        setIntentValue("1");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName  + ". It is currently in transit. We will make every effort to deliver it ASAP.";
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null || data[product].totalAttemptCount == "None" || data[product].totalAttemptCount == "NULL")) {
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We will try to deliver it as soon as possible. You will be notified by SMS and a phone call once its out for delivery."
                    }
                    else if (data[product].status == 'Delivered' && data[product].orderStatus == 'Delivered') {
                        setIntentValue("100");
                        setShipmentStatus("Delivered");
                        let deliveryDate = data[product].deliveryDateTime
                        setDDT(deliveryDate);
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We are pleased to inform you that it has been successfully delivered on " + deliveryDate + "."
                    }
                    else if (data[product].status == 'RTO') {
                        const craResponse = await tryRouteCraNdr(data[product]);
                        if (craResponse) {
                            return craResponse;
                        }
                        setIntentValue("2");
                        setShipmentStatus("RTO");
                        // #enhancements_pxb5559 changes done according workflow enhancements
                        if (data[product].orderStatus == 'WHHandover') {
                            setIntentValue("107");
                            setWHHandOver('true');
                            if (data[product].totalAttemptCount > 1) {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". It has been successfully returned to its origin as per instructions from client. Please contact them in case you have any queries."
                            }
                            else {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". It has been successfully returned to its origin as per instructions from client. Please contact them in case you have any queries."
                            }
                        }
                        else {
                            if (data[product].totalAttemptCount > 1) {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                            }
                            else {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                            }
                        }
                    }
                    else if (data[product].status == 'Lost') {
                        setShipmentStatus("Lost");
                        setIntentValue("4");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. We are unable to deliver it because it has been lost in transit. Please contact client in case you have any queries."
                    }
                    else if (data[product].status == 'STD') {
                        setShipmentStatus("STD");
                        setIntentValue("3");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. We are unable to deliver it because it has been damaged in transit. Please contact client in case you have any queries."
                    }
                }
                else {
                    // #enhancements_pxb5559 changes done according workflow enhancements
                    setIntentValue("106");
                    setShipmentStatus("Inscan");
                    setClientName(data[product].clientName);
                    if (data[product].orderPDD == 'None' || data[product].orderPDD == null) {
                        data[product].orderPDD = data[product].orderEDD
                        setEDD(data[product].orderEDD)
                        pddDate = eddDate;
                    }
                    setPddBreach(pddDate >= dateTime ? 'false' : 'true');
                    const cwfdResponse = await tryRouteCwfdCnaNdr(data[product]);
                    if (cwfdResponse) {
                        return cwfdResponse;
                    }
                    const craResponse = await tryRouteCraNdr(data[product]);
                    if (craResponse) {
                        return craResponse;
                    }
                    const adiResponse = await tryRouteAddressIncompleteNdr(data[product]);
                    if (adiResponse) {
                        return adiResponse;
                    }
                    const pncResponse = await tryRouteNdrPaymentCouldNotBeCompleted(data[product]);
                    if (pncResponse) {
                        return pncResponse;
                    }
                    if (data[product].status == 'Shipped' && data[product].notificationType == 'RTO' && data[product].orderStatus == 'InScan' && data[product].ndrCode == 'Out for Delivery') {
                        setShipmentStatus("OFD");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. Currently, it is in transit and has not reached its destination yet. We will try to deliver it by " + data[product].orderPDD + "."
                    }
                    // #enhancements_pxb5559 changes done according workflow enhancements
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && data[product].ndrCode == 'Out for Delivery' && pddDate >= dateTime) {
                        setShipmentStatus("OFD");
                        setIntentValue("1")
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". It is out for delivery today. Our service representative will contact you shortly to ensure smooth delivery."
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && data[product].ndrCode == 'Out for Delivery' && pddDate < dateTime) {
                        setShipmentStatus("OFD");
                        setIntentValue("14");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + ",  but due to unforeseen circumstances, the shipment was delayed. Good news! It is out for delivery today. Our service representative will contact you shortly to ensure smooth delivery. Thank you for your understanding and patience!";
                    }
                    
                    else if (data[product].status === 'Shipped' && data[product].orderStatus === 'InScan' && data[product].notificationType === 'CSAW' && data[product].notificationStatus === "Pending" && data[product].totalAttemptCount >= 1) {
                        // V NDR
                        return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. We were unable to deliver it due to ${data[product].ndrCode} on ${data[product].lastNDRDate}. We are currently awaiting further instructions from the client. Once we receive the updated date of delivery, we will process the request and ensure it is delivered as soon as possible. Thank you for your patience and understanding!`;
                    }
                    else if (data[product].status === 'Shipped' && data[product].orderStatus === 'InScan' && normalizeText(data[product].notificationStatus) === 'reattempt' && data[product].totalAttemptCount >= 1) {
                        const cwfdReattemptResponse = await tryRouteCwfdCnaNdr(data[product]);
                        if (cwfdReattemptResponse) {
                            return cwfdReattemptResponse;
                        }
                        const cwfdFallback = await routeCwfdCnaIfNdrReasonMatches(data[product]);
                        if (cwfdFallback) {
                            return cwfdFallback;
                        }
                        // UN NDR
                        if (data[product].reattemptDate == 'None' || data[product].reattemptDate == null) {
                            return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. We were unable to deliver it due to ${data[product].ndrCode} on ${data[product].lastNDRDate}. We will reattempt delivery on ${getFutureDate()}. Thank you for your patience and understanding!`;
                        } else {
                            return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. We were unable to deliver it due to ${data[product].ndrCode} on ${data[product].lastNDRDate}. We will reattempt delivery on  ${data[product].reattemptDate}. Thank you for your patience and understanding!`;
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].notificationType == 'RTO') {
                        setIntentValue("2");
                        if (data[product].totalAttemptCount >= 1) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus != 'InScan' && pddDate >= dateTime) {
                        if (data[product].orderEDD == 'None' || data[product].orderEDD == null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Currently it is in transit and has not reached destination. We will try to deliver it ASAP."
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Currently it is in transit and has not reached destination. We will try to deliver it by " + data[product].orderPDD + "."
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus != 'InScan' && pddDate < dateTime) {
                        if (data[product].orderEDD == 'None' || data[product].orderEDD == null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. Due to unforeseen circumstances, the shipment has been delayed. Rest assured, we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!"
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + ", but due to unforeseen circumstances, the shipment has been delayed. Rest assured, we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!";
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate >= dateTime && data[product].totalAttemptCount >= 1) {
                        const cwfdBeforeGeneric = await tryRouteCwfdCnaNdr(data[product]);
                        if (cwfdBeforeGeneric) {
                            return cwfdBeforeGeneric;
                        }
                        if (pddDate < dateTime) {
                            var verb = 'was'
                        }
                        if (pddDate >= dateTime) {
                            var verb = 'is'
                        }
                        if (data[product].reattemptDate != 'None' && data[product].reattemptDate != null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through "+ data[product].clientName + ". Its estimated date of delivery " + verb + " " + data[product].orderPDD + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". We will reattempt to deliver it by " + data[product].reattemptDate + "."
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Its estimated date of delivery " + verb + " " + data[product].orderPDD + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + "."
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate >= dateTime && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null) && (data[product].currentHubID === data[product].finalHubID)) {
                        setIntentValue("1");
                        // #enhancements_pxb5559 changes done according workflow enhancements
                        return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. Its estimated delivery date is ${data[product].orderPDD}, and it has already reached its destination. We are on track to deliver it by ${data[product].orderPDD}.`;
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate >= dateTime && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null) && (data[product].originHubID !== data[product].currentHubID && data[product].currentHubID !== data[product].finalHubID)) {
                        setIntentValue("1");
                        return `The shipment with ID ${data[product].poid} is a ${type} order placed through ${data[product].clientName}. Its estimated delivery date is ${data[product].orderPDD}, and it is currently in transit. We will make every effort to ensure it is delivered by ${data[product].orderPDD}.`;
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate >= dateTime && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null)) {
                        setIntentValue("1");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Its estimated date of delivery is " + data[product].orderPDD + ". We will make every effort to deliver it by " + data[product].orderPDD + ".";
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate < dateTime && data[product].totalAttemptCount >= 1) {
                        const cwfdBeforeGeneric = await tryRouteCwfdCnaNdr(data[product]);
                        if (cwfdBeforeGeneric) {
                            return cwfdBeforeGeneric;
                        }
                        setIntentValue("1");
                        if (pddDate < dateTime) {
                            var verb = 'was'
                        }
                        if (pddDate >= dateTime) {
                            var verb = 'is'
                        }
                        if (data[product].reattemptDate == 'None' || data[product].reattemptDate == null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Its estimated date of delivery was " + data[product].orderPDD + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + "."
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". Its estimated date of delivery " + verb + " " + data[product].orderPDD + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". We will reattempt to deliver it on " + data[product].reattemptDate + "."
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate < dateTime && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null) && (data[product].currentHubID === data[product].finalHubID)) {
                        setIntentValue("14");
                        if (data[product].orderEDD == 'None' || data[product].orderEDD == null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + " but due to unforeseen circumstances, the shipment has been delayed. Good news! The shipment has reached its destination, and we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!";
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + " but due to unforeseen circumstances, the shipment has been delayed. Good news! The shipment has reached its destination, we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!";
                        }
                    }
                    else if (data[product].status == 'Shipped' && data[product].orderStatus == 'InScan' && pddDate < dateTime && (data[product].totalAttemptCount == 0 || data[product].totalAttemptCount == null)) {
                        setIntentValue("14");
                        if (data[product].orderEDD == 'None' || data[product].orderEDD == null) {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + " but due to unforeseen circumstances, the shipment has been delayed. Rest assured, we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!";
                        }
                        else {
                            return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We sincerely apologize for the delay. The estimated delivery date was " + data[product].orderPDD + " but due to unforeseen circumstances, the shipment has been delayed. Rest assured, we are working to ensure it is delivered at the earliest possible time. Our support team will keep you updated on the progress. Thank you for your understanding and patience!";
                        }
                    }
                    else if (data[product].status == 'Delivered' && data[product].orderStatus == 'Delivered') {
                        setIntentValue("100");
                        setShipmentStatus("Delivered");
                        let deliveryDate = data[product].deliveryDateTime
                        setDDT(deliveryDate);
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We are pleased to inform you that it has been successfully delivered on " + deliveryDate + "."
                    }
                    else if (data[product].status == 'RTO') {
                        const craResponse = await tryRouteCraNdr(data[product]);
                        if (craResponse) {
                            return craResponse;
                        }
                        setShipmentStatus("RTO");
                        if (data[product].orderStatus == 'WHHandover') {
                            setIntentValue("107");
                            setWHHandOver('true');
                            if (data[product].totalAttemptCount > 1) {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because. It has been successfully returned to its origin as per instructions from client. Please contact them in case you have any queries."
                            }
                            else {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                            }
                        }
                        else {
                            setIntentValue("2");
                            if (data[product].totalAttemptCount > 1) {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We tried but could not deliver it because " + data[product].ndrCode + " on " + data[product].lastNDRDate + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                            }
                            else {
                                return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". As per the instructions from the client, the shipment will be returned to its origin. For any queries or further details, please contact the client directly.";
                            }
                        }
                    }
                    else if (data[product].status == 'Lost') {
                        setShipmentStatus("RTO");
                        setIntentValue("4");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. We are unable to deliver it because it has been lost in transit. Please contact client in case you have any queries."
                    }
                    else if (data[product].status == 'STD') {
                        setShipmentStatus("RTO");
                        setIntentValue("3");
                        return "The shipment with ID " + data[product].poid + " is a " + type + " order placed through " + data[product].clientName + ". We apologise. We are unable to deliver it because it has been damaged in transit. Please contact client in case you have any queries."
                    }
                    else {
                        setIntentValue("99");
                        return "Sorry! I couldn't find any shipments with the mentioned ID. \n Please enter a valid Shipment ID or your registered Mobile number.";
                    }
                }
            }
            else if (data[product].businessType == "reverse") {
                // #enhancements_pxb5559 changes done according workflow enhancements
                setBusinessType("reverse");
                setDDT(data[product].manifestDataReceived);
                setClientName(data[product].clientName);
                    
                if (data[product].reattemptDate != 'None' && data[product].reattemptDate != null) {
                    data[product].reattemptDate = data[product].reattemptDate.split(" ")[0];
                    setReattemptDate(data[product].reattemptDate);
                }
                if (data[product].lastNDRDate && data[product].lastNDRUserProcess) {
                    setNDR(data[product].lastNDRUserProcess);
                    setNDRDate(data[product].lastNDRDate);
                }
                if (data[product].lastNDR) {
                    setNDR(data[product].lastNDR);
                }
                if (data[product].lastNDRDateTime) {
                    setNDRDate(data[product].lastNDRDateTime);
                }
                // === REMOVE_BEFORE_GO_LIVE: gate reverse NPR special flows to LatestStatus=npr ===
                const reverseLatestStatus = normalizeText(
                    data[product].latestStatus || data[product].LatestStatus || ''
                );
                if (reverseLatestStatus === 'npr') {
                    const nprSpecialFlowResponse = await routeReverseNprSpecialFlows(data[product]);
                    if (nprSpecialFlowResponse) {
                        return nprSpecialFlowResponse;
                    }
                }
                // === END REMOVE_BEFORE_GO_LIVE ===
                if (data[product].status == 'Pending' && data[product].ndrCode == 'Out for PickUp') {
                    setIntentValue("108");
                    setShipmentStatus("OFP");
                    return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". Our service representative is currently out for pickup and will contact you shortly. Thank you for your patience!";
                }

                else if (data[product].status == 'Pending' && data[product].orderStatus == 'PickupNotDone') {
                    setIntentValue("109");
                    setShipmentStatus("Manifestation");
                    if (data[product].totalAttemptCount >= 1) {
                        setAttemptCount("1");
                        if (data[product].notificationType === 'CSAW' && data[product].notificationStatus === "Pending") {
                            // V NDR
                            return `The pickup request for Shipment ID ${data[product].poid} was initiated by ${data[product].clientName} on ${data[product].manifestDataReceived}. We attempted to pick up the product but were unable to proceed due to ${data[product].lastNDRUserProcess} on ${data[product].lastNDRDate}. We are currently awaiting further instructions from the client. Once we receive the updated pickup date, we will process the request and ensure the product is picked up as soon as possible. Thank you for your patience and understanding!`;
                        } else if (data[product].reattemptDate == null || data[product].reattemptDate == 'None') {
                            return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will try to pick it as soon as possible. You will be notified by SMS and a phone call once it is out for pick up."
                        }
                        else {
                            let splitReattemptDate = await splitDate(data[product].reattemptDate)
                            let eligibleDate = await getEligiblityDate(splitReattemptDate, 'Reattempt')
                            if (eligibleDate == 'ASAP') {
                                return `The pickup request for Shipment ID ${data[product].poid} was initiated by ${data[product].clientName} on ${data[product].manifestDataReceived}. We attempted to pick up the product but were unable to proceed due to ${data[product].lastNDRUserProcess} on ${data[product].lastNDRDate}. We will try to pick up the product as soon as possible. You will be notified via SMS and a phone call once the pickup is scheduled. Thank you for your patience and understanding!`;
                            }
                            else {
                                return `The pickup request for Shipment ID ${data[product].poid} was initiated by ${data[product].clientName} on ${data[product].manifestDataReceived}. We attempted to pick up the product but were unable to proceed due to ${data[product].lastNDRUserProcess} on ${data[product].lastNDRDate}. We will try to pick up the product it on ${eligibleDate}. Thank you for your patience and understanding!`;
                            }

                        }
                    }
                    else {
                        if (data[product].manifestDataReceived == null || data[product].manifestDataReceived == 'None') {
                            let splitReattemptDate = await splitDate(data[product].reattemptDate)
                            let eligibleDate = await getEligiblityDate(splitReattemptDate, 'Reattempt')
                            return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will try to pick it as soon as possible. You will be notified by SMS and a phone call once it is out for pick up."
                        }
                        else {
                            let splitmanifestDate = await splitDate(data[product].manifestDataReceived)
                            let eligibleDate = await getEligiblityDate(splitmanifestDate, 'Manifest')
                            if (eligibleDate == "ASAP") {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We will try to pick up the product " + eligibleDate + "."
                            }
                            else {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We will try to pick up the product on " + eligibleDate + "."
                            }

                        }
                    }
                }
                // #enhancements_pxb5559 changes done according workflow enhancements
                else if (data[product].status == 'Pending' && (data[product].ndrCode === "pick up done" || data[product].ndrCode === "Pick up done")) {
                    setIntentValue("111");
                    setShipmentStatus("PickedUp");
                    return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + ". We successfully picked up the product on " + data[product].manifestDataReceived + ", and it will be returned to its origin very soon."
                }

                else if (data[product].status == 'Pending') {
                    setIntentValue("108");
                    setShipmentStatus("Manifestation");
                    if (data[product].totalAttemptCount >= 1) {
                        setAttemptCount("1");
                        if (data[product].reattemptDate == null || data[product].reattemptDate == 'None') {
                            return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will try to pick it as soon as possible. You will be notified by SMS and a phone call once it is out for pick up."
                        }
                        else {
                            let splitReattemptDate = await splitDate(data[product].reattemptDate)
                            let eligibleDate = await getEligiblityDate(splitReattemptDate, 'Reattempt')
                            if (eligibleDate == 'ASAP') {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will reattempt to pick it " + eligibleDate + "."
                            }
                            else {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will reattempt to pick it on " + eligibleDate + "."
                            }

                        }
                    }
                    else {
                        if (data[product].manifestDataReceived == null || data[product].manifestDataReceived == 'None') {
                            let splitReattemptDate = await splitDate(data[product].reattemptDate)
                            let eligibleDate = await getEligiblityDate(splitReattemptDate, 'Reattempt')
                            return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". We will try to pick it as soon as possible. You will be notified by SMS and a phone call once it is out for pick up."
                        }
                        else {
                            let splitmanifestDate = await splitDate(data[product].manifestDataReceived)
                            let eligibleDate = await getEligiblityDate(splitmanifestDate, 'Manifest')
                            if (eligibleDate == "ASAP") {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We will attempt to pick up the product " + eligibleDate + ". Thank you for your patience!"
                            }
                            else {
                                return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We will attempt to pick up the product on " + eligibleDate + ". Thank you for your patience!"
                            }

                        }
                    }
                }
                else if (data[product].orderStatus == 'RPCancel') {
                    setIntentValue("110");
                    if (data[product].totalAttemptCount >= 1) {
                        return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". We tried but could not pick the product because " + data[product].lastNDRUserProcess + " on " + data[product].lastNDRDate + ". The pickup request has been cancelled as per instructions by the client. Please contact them in case you have any queries."
                    }
                    else {
                        return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " on " + data[product].manifestDataReceived + ". The pickup request has been cancelled as per instructions by the client. Please contact them in case you have any queries."
                    }
                }
                else if (data[product].orderStatus == 'PickupDone') {
                    setIntentValue("111");
                    setShipmentStatus("PickedUp");
                    setDDT(data[product].manifestDataReceived);
                    return "The pickup request for Shipment ID " + data[product].poid + " was initiated by " + data[product].clientName + " We successfully picked up the product on " + data[product].manifestDataReceived + ", and it will be returned to its origin very soon."
                }
                // #enhancements_pxb5559 changes done according workflow enhancements
                else if (data[product].status === 'DTO' && data[product].orderStatus === "WHHandover") {
                    setIntentValue("113");
                    setShipmentStatus("DTO");
                    setWHHandOver('true');
                    setDDT(data[product].manifestDataReceived);
                    return `The pickup request for Shipment ID ${data[product].poid } was initiated by ${data[product].clientName}. We have successfully picked up the product on ${data[product].manifestDataReceived}, and it will be delivered to its origin very soon. For any queries, please feel free to contact ${data[product].clientName} directly. Thank you for your understanding!`;
                }
                else if (data[product].status == 'DTO') {
                    setIntentValue("113");
                    setShipmentStatus("DTO");
                    setDDT(data[product].manifestDataReceived);
                    return `The pickup request for Shipment ID ${data[product].poid} was initiated by ${data[product].clientName}. We have successfully picked up the product on ${data[product].manifestDataReceived}, and it will be delivered to its origin very soon. For any queries, please feel free to contact ${data[product].clientName} directly. Thank you for your understanding!`;
                }
                else if (data[product].status == 'Shipped') {
                    setIntentValue("111");
                    setShipmentStatus("DTO");
                    setDDT(data[product].manifestDataReceived);
                    return `The pickup request for Shipment ID ${data[product].poid} was initiated by ${data[product].clientName}. We have successfully picked up the product on ${data[product].manifestDataReceived}, and it will be delivered to its origin very soon. For any queries, please feel free to contact ${data[product].clientName} directly. Thank you for your understanding!`;
                }
                else {
                    setIntentValue("99");
                    return "Sorry! I couldn't find any shipments with the mentioned ID. \n Please enter a valid Shipment ID or your registered Mobile number."
                }
            }
        }
    } catch (error) {
        return 'No data found';
    }
}

async function eligibleDateFormat(date) {
    try {
        var day = date;
        var dt = day.getDate() + '-' + (day.getMonth() + 1) + '-' + day.getFullYear();
        return dt
    } catch (error) {
        console.log('Error in function eligibleDateFormat', error);
    }
}

async function setDateHMS(h, m, s, date) {
    date.setHours(h)
    date.setMinutes(m)
    date.setSeconds(s)
    return date
}

async function getEligiblityDate(date, flag) {
    try {
        if (flag == 'Manifest') {
            let date1 = new Date()
            date1.setDate(date1.getDate(date1) - 1)
            date1 = await setDateHMS(13, 20, 0, date1)
            let date2 = new Date()
            date2 = await setDateHMS(7, 49, 59, date2)
            let date3 = new Date()
            date3 = await setDateHMS(7, 50, 0, date3)
            let date4 = new Date()
            date4 = await setDateHMS(10, 29, 59, date4)
            let date5 = new Date()
            date5 = await setDateHMS(10, 30, 0, date5)
            let date6 = new Date()
            date6 = await setDateHMS(13, 19, 59, date6)
            if (date < date1) {
                let eligibleDate = 'ASAP'
                return eligibleDate;
            }
            else if (date > new Date()) {
                let eligibleDate = await eligibleDateFormat(date)
                return eligibleDate;
            }
            else if ((date > date1) && (date < date2)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
            else if ((date > date3) && (date < date4)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
            else if ((date > date5) && (date < date6)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
    
            else if (date > date6) {
                let eligibleDate = new Date()
                eligibleDate.setDate(eligibleDate.getDate() + 1)
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
        }
        else {
            let date1 = new Date()
            date1.setDate(date1.getDate(date1) - 1)
            date1 = await setDateHMS(16, 0, 0, date1)
            let date2 = new Date()
            date2 = await setDateHMS(7, 49, 59, date2)
            let date3 = new Date()
            date3 = await setDateHMS(7, 50, 0, date3)
            let date4 = new Date()
            date4 = await setDateHMS(10, 29, 59, date4)
            let date5 = new Date()
            date5 = await setDateHMS(10, 30, 0, date5)
            let date6 = new Date()
            date6 = await setDateHMS(13, 19, 59, date6)
            let date7 = new Date()
            date7 = await setDateHMS(13, 20, 0, date7)
            let date8 = new Date()
            date8 = await setDateHMS(15, 59, 59, date8)
            if (date < date1) {
                let eligibleDate = 'ASAP'
                return eligibleDate;
            }
            else if (date > new Date()) {
                let eligibleDate = await eligibleDateFormat(date)
                return eligibleDate;
            }
            else if ((date > date1) && (date < date2)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
            else if ((date > date3) && (date < date4)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
            else if ((date > date5) && (date < date6)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
            else if ((date > date7) && (date < date8)) {
                let eligibleDate = new Date()
                eligibleDate = await eligibleDateFormat(eligibleDate)
                return eligibleDate
            }
        }
    } catch (error) {
        console.log('Error in function getEligiblityDate', error);
    }
}

async function splitDate(date) {
    try {
        let day = date
        let dateSplit = day.split(" ")
        let dd = dateSplit[0].split("-", 1)[0]
        let mm = dateSplit[0].split("-", 2)[1]
        mm = mm - 1
        let yy = dateSplit[0].split("-")[2]

        let finalDate = new Date(yy, mm, dd)
        return finalDate
    } catch (error) {
        console.log('Error in function splitDate', error);
    }
}

function returnTime() {
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime
}

async function appendordercard_list(data) {
    try {
        let responseArray = [];
        // #features_pxb5559 prompt change based on input
        if (data && data.length == 0) {
            let registeredNo = getNumber();
            if (!registeredNo)
                return constants.INVALID_AWB_MESSAGE;
            else
                return constants.INVALID_MOBILE_MESSAGE;
        }        
        let shipmentsType = data && data.length > 1 ? "Multiple Shipments" : "Single Shipment";
        const respArr = await fetchOptionsOfInput(shipmentsType, false);
        if (respArr.length) {
            for (let obj of respArr) {
                let Obj = { type: 'text', content: obj.content, timestamp : returnTime()}
                responseArray.push(Obj);
            }
        }
        for (let product = 0; product < data.length; product++) {
            let obj = {
                type: 'button',
                content: `Shipment ID : ${data[product].shipment_id}
                            Status : ${data[product].shipment_status}`
            }
            responseArray.push(obj);
        }
        return responseArray;
    } catch (error) {
        return [];
    }
}

export async function dataReceived(data) {
    try {
        for (let element = 0; element < data.response.length; element++) {
            if (element == 0) {
                if (element == data.response.length - 1) {
                    if (data.response[element]['type'] == 'text') {
                        return data.response[element]['text'];
                    } else if (data.response[element]['type'] == 'orderCard') {
                        let msg = await appendResponse(data.response[element]['orderCard']);
                        return msg;
                    } else if (data.response[element]['type'] == 'orderCard_list') {
                        let resp = await appendordercard_list(data.response[element]['orderCard_list']);
                        return resp;
                    } else if (data.response[element]['type'] == 'closemenu') {
                        let resp = await fetchOptionsOfInput(additionalOptions, false);
                        return resp;
                    }
                } else {
                    if (data.response[element]['type'] == 'text') {
                        return data.response[element]['text'];
                    } else if (data.response[element]['type'] == 'orderCard') {
                        let msg = await appendResponse(data.response[element]['orderCard']);
                        return msg;
                    } else if (data.response[element]['type'] == 'orderCard_list') {
                        let resp = await appendordercard_list(data.response[element]['orderCard_list']);
                        return resp;
                    } else if (data.response[element]['type'] == 'closemenu') {
                        let resp = await fetchOptionsOfInput(additionalOptions, false);
                        return resp;
                    }
                }
            } else if (element > 0) {
                if (element == data.response.length - 1) {
                    if (data.response[element]['type'] == 'text') {
                        return data.response[element]['text'];
                    } else if (data.response[element]['type'] == 'orderCard') {
                        let msg = await appendResponse(data.response[element]['orderCard']);
                        return msg;
                    } else if (data.response[element]['type'] == 'orderCard_list') {
                        let resp = await appendordercard_list(data.response[element]['orderCard_list']);
                        return resp;
                    } else if (data.response[element]['type'] == 'closemenu') {
                        let resp = await fetchOptionsOfInput(additionalOptions, false);
                        return resp;
                    } 
                } else {
                    if (data.response[element]['type'] == 'text') {
                        return data.response[element]['text']
                    } else if (data.response[element]['type'] == 'orderCard') {
                        return await appendResponse(data.response[element]['orderCard']);
                    }  else if (data.response[element]['type'] == 'orderCard_list') {
                        let resp = await appendordercard_list(data.response[element]['orderCard_list']);
                        return resp;
                    } else if (data.response[element]['type'] == 'closemenu') {
                        let resp = await fetchOptionsOfInput(additionalOptions, false);
                        return resp;
                    }
                }
            }
        }
    } catch (error) {
        console.log('error in function dataReceived', error)
        return 'No data found catch'
    }
}